var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodingAssessmentRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-29"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.79,344.39s11.93-17.08,3.7-36.69-3.39-27.06-3.39-27.06l8,15.87s7.49-11.73,4.55-25.49,3.83-36.92,3.83-36.92-2.44,26.8,1.84,37.44c0,0,6.26-10.32,8.49-20.74s9.07-31,9.07-31l-10.48,63.8,23-28.79s-23.41,39-26.53,46.6l25.44-12.69s-12.47,19.56-22.33,23.3-20.58,34.24-20.58,34.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.27,352.06s-10.36-21,2.07-41.33,8.33-29.46,8.33-29.46l-11.53,16.27s-6.34-14.27-.75-29.05,2-41.61,2-41.61S414.55,257,408,268.12c0,0-5.2-12.51-5.92-24.45s-4.85-35.93-4.85-35.93l.88,72.56L377.5,244.48s19.4,47.22,21.58,56.19L373,282.29c1.64-.65,16.42,21.45,20.85,29.62,5.65,10.4,17.06,41.45,17.06,41.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.82 342.94 443.63 342.94 438.63 382.62 386.82 382.62 381.82 342.94",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.11,152.8a12.48,12.48,0,0,1-5-4.68,13.74,13.74,0,0,1,0-13.67,12.51,12.51,0,0,1,5-4.69,15.3,15.3,0,0,1,7.21-1.68,15.74,15.74,0,0,1,6.56,1.3,12.22,12.22,0,0,1,4.76,3.75l-5.37,4.8a6.9,6.9,0,0,0-5.52-3,5.63,5.63,0,0,0-4.29,1.71,7.34,7.34,0,0,0,0,9.2,5.63,5.63,0,0,0,4.29,1.71,6.88,6.88,0,0,0,5.52-3l5.37,4.79a12,12,0,0,1-4.76,3.75,15.74,15.74,0,0,1-6.56,1.3A15.3,15.3,0,0,1,384.11,152.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.06,144.35h-5.95v5.77h-6.5v-5.77h-5.95v-6.13h5.95v-5.77h6.5v5.77h5.95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.6,226.43a7.72,7.72,0,0,1-3.1-2.89,8.47,8.47,0,0,1,0-8.42,7.79,7.79,0,0,1,3.1-2.89,9.56,9.56,0,0,1,4.44-1,9.82,9.82,0,0,1,4,.8,7.47,7.47,0,0,1,2.93,2.31l-3.31,3a4.23,4.23,0,0,0-3.4-1.82,3.47,3.47,0,0,0-2.64,1.05,4.52,4.52,0,0,0,0,5.67,3.47,3.47,0,0,0,2.64,1.05,4.23,4.23,0,0,0,3.4-1.82l3.31,3a7.66,7.66,0,0,1-2.93,2.31,9.82,9.82,0,0,1-4,.8A9.44,9.44,0,0,1,114.6,226.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.6,221.22h-3.67v3.56h-4v-3.56h-3.66v-3.78h3.66v-3.55h4v3.55h3.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.51,87.86a6.76,6.76,0,0,1-2.73-2.54,7.43,7.43,0,0,1,0-7.41,6.85,6.85,0,0,1,2.73-2.55,8.41,8.41,0,0,1,3.91-.91,8.57,8.57,0,0,1,3.56.71,6.56,6.56,0,0,1,2.59,2l-2.92,2.6a3.73,3.73,0,0,0-3-1.6,3.06,3.06,0,0,0-2.33.93,4,4,0,0,0,0,5,3.06,3.06,0,0,0,2.33.93,3.74,3.74,0,0,0,3-1.61L272.57,86a6.65,6.65,0,0,1-2.59,2,8.57,8.57,0,0,1-3.56.7A8.29,8.29,0,0,1,262.51,87.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.49,88.39a8.83,8.83,0,0,1-2.65-1L274.33,84a9.41,9.41,0,0,0,2.19.91,8.48,8.48,0,0,0,2.33.34,3.74,3.74,0,0,0,1.37-.18.61.61,0,0,0,.41-.56c0-.29-.18-.5-.54-.65a12.14,12.14,0,0,0-1.77-.47,20.19,20.19,0,0,1-2.64-.71,4.41,4.41,0,0,1-1.84-1.25,3.41,3.41,0,0,1-.78-2.36,4.1,4.1,0,0,1,.72-2.35,4.75,4.75,0,0,1,2.16-1.66,8.92,8.92,0,0,1,3.5-.61,12.17,12.17,0,0,1,2.76.31,8.31,8.31,0,0,1,2.4.89L283.21,79a8.44,8.44,0,0,0-3.81-1c-1.19,0-1.78.29-1.78.87,0,.27.17.47.52.61a11.63,11.63,0,0,0,1.75.44,17.87,17.87,0,0,1,2.64.68,4.55,4.55,0,0,1,1.87,1.24,3.37,3.37,0,0,1,.79,2.35,4,4,0,0,1-.73,2.34,4.89,4.89,0,0,1-2.16,1.66,8.86,8.86,0,0,1-3.49.61A14.09,14.09,0,0,1,275.49,88.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.35,88.39a8.73,8.73,0,0,1-2.65-1L287.18,84a9.67,9.67,0,0,0,2.2.91,8.41,8.41,0,0,0,2.32.34,3.7,3.7,0,0,0,1.37-.18.6.6,0,0,0,.42-.56c0-.29-.18-.5-.54-.65a12.14,12.14,0,0,0-1.77-.47,20.84,20.84,0,0,1-2.65-.71,4.54,4.54,0,0,1-1.84-1.25,3.41,3.41,0,0,1-.78-2.36,4,4,0,0,1,.73-2.35,4.75,4.75,0,0,1,2.16-1.66,8.86,8.86,0,0,1,3.49-.61,12.25,12.25,0,0,1,2.77.31,8.31,8.31,0,0,1,2.4.89L296.07,79a8.51,8.51,0,0,0-3.82-1c-1.19,0-1.78.29-1.78.87,0,.27.18.47.53.61a11.11,11.11,0,0,0,1.74.44,17.55,17.55,0,0,1,2.64.68,4.49,4.49,0,0,1,1.87,1.24,3.33,3.33,0,0,1,.79,2.35,4,4,0,0,1-.72,2.34,4.89,4.89,0,0,1-2.16,1.66,8.92,8.92,0,0,1-3.5.61A14,14,0,0,1,288.35,88.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.09,261.91a3.5,3.5,0,0,1-1.37-1.27,3.54,3.54,0,0,1-.49-1.86,3.48,3.48,0,0,1,.49-1.85,3.36,3.36,0,0,1,1.37-1.27,4.08,4.08,0,0,1,2-.46,4.42,4.42,0,0,1,1.78.35,3.41,3.41,0,0,1,1.29,1l-1.46,1.3a1.87,1.87,0,0,0-1.5-.8,1.51,1.51,0,0,0-1.16.46,2,2,0,0,0,0,2.5,1.51,1.51,0,0,0,1.16.46,1.85,1.85,0,0,0,1.5-.8l1.46,1.3a3.23,3.23,0,0,1-1.29,1,4.25,4.25,0,0,1-1.78.35A4.19,4.19,0,0,1,153.09,261.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.58,262.17a4.74,4.74,0,0,1-1.33-.51L159,260a4.88,4.88,0,0,0,1.09.45,4.53,4.53,0,0,0,1.17.17,1.8,1.8,0,0,0,.68-.09.3.3,0,0,0,.21-.28c0-.14-.09-.25-.27-.32a6.75,6.75,0,0,0-.89-.24,11.59,11.59,0,0,1-1.32-.35,2.3,2.3,0,0,1-.92-.63,1.7,1.7,0,0,1-.39-1.18,2,2,0,0,1,.36-1.17,2.45,2.45,0,0,1,1.08-.84,4.57,4.57,0,0,1,1.75-.3,6.5,6.5,0,0,1,1.39.15,4.09,4.09,0,0,1,1.19.45l-.69,1.67a4.24,4.24,0,0,0-1.91-.51c-.59,0-.89.15-.89.43s.09.24.27.31a5.26,5.26,0,0,0,.87.22,8.93,8.93,0,0,1,1.32.34,2.24,2.24,0,0,1,.93.62,1.65,1.65,0,0,1,.4,1.17,2,2,0,0,1-.36,1.17,2.46,2.46,0,0,1-1.09.83,4.3,4.3,0,0,1-1.74.31A7,7,0,0,1,159.58,262.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,262.17a4.74,4.74,0,0,1-1.33-.51l.75-1.68a4.88,4.88,0,0,0,1.09.45,4.47,4.47,0,0,0,1.17.17,1.84,1.84,0,0,0,.68-.09.3.3,0,0,0,.21-.28c0-.14-.09-.25-.27-.32a6.75,6.75,0,0,0-.89-.24,11.05,11.05,0,0,1-1.32-.35,2.3,2.3,0,0,1-.92-.63,1.7,1.7,0,0,1-.39-1.18,2,2,0,0,1,.36-1.17,2.39,2.39,0,0,1,1.08-.84,4.54,4.54,0,0,1,1.75-.3,6.34,6.34,0,0,1,1.38.15,4,4,0,0,1,1.2.45l-.69,1.67A4.24,4.24,0,0,0,168,257c-.59,0-.89.15-.89.43s.09.24.26.31a5.88,5.88,0,0,0,.87.22,8.77,8.77,0,0,1,1.33.34,2.31,2.31,0,0,1,.93.62,1.69,1.69,0,0,1,.4,1.17,2,2,0,0,1-.37,1.17,2.38,2.38,0,0,1-1.08.83,4.33,4.33,0,0,1-1.74.31A7,7,0,0,1,166,262.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.3,82a3,3,0,0,1,1.33,1.1,3,3,0,0,1-1.33,4.47,5.07,5.07,0,0,1-2,.38h-1.21V90h-2.83v-8.4h4A4.9,4.9,0,0,1,208.3,82ZM207,85.51a.91.91,0,0,0,.29-.73.89.89,0,0,0-.29-.72,1.21,1.21,0,0,0-.86-.26h-1v2h1A1.26,1.26,0,0,0,207,85.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.3,81.61V90h-2.83V86.92h-2.62V90H211v-8.4h2.83v3h2.62v-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.74,82a2.91,2.91,0,0,1,1.33,1.1,3.24,3.24,0,0,1,0,3.36,3,3,0,0,1-1.33,1.11,5,5,0,0,1-2,.38H223.5V90h-2.83v-8.4h4A4.87,4.87,0,0,1,226.74,82Zm-1.34,3.51a.94.94,0,0,0,.29-.73.92.92,0,0,0-.29-.72,1.22,1.22,0,0,0-.87-.26h-1v2h1A1.27,1.27,0,0,0,225.4,85.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.05,272.9v12.84h-4.33V281h-4v4.73H308.4V272.9h4.33v4.55h4V272.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.4,285.39a5.26,5.26,0,0,1-2.55.53,4.66,4.66,0,0,1-3.24-1,3.87,3.87,0,0,1-1.14-3v-2.57h-1.38v-3h1.38v-2.81h4.14v2.81h2.05v3h-2.05v2.53a1,1,0,0,0,.24.72.82.82,0,0,0,.62.26,1.65,1.65,0,0,0,.94-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.62,276.64a4.66,4.66,0,0,1,1.09,3.38v5.72h-4.14v-5c0-1.15-.37-1.72-1.12-1.72a1.12,1.12,0,0,0-.94.44,2.18,2.18,0,0,0-.36,1.39v4.9H338v-5c0-1.15-.38-1.72-1.12-1.72a1.15,1.15,0,0,0-.95.44,2.25,2.25,0,0,0-.35,1.39v4.9h-4.15v-10h3.94v.93a3.89,3.89,0,0,1,2.85-1.11,4.25,4.25,0,0,1,1.81.37,3.11,3.11,0,0,1,1.32,1.15,4,4,0,0,1,1.47-1.13,4.5,4.5,0,0,1,1.89-.39A3.88,3.88,0,0,1,347.62,276.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.51,272.13h4.14v13.61h-4.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5,130.69v8.25h-2.78v-3h-2.57v3h-2.79v-8.25h2.79v2.92h2.57v-2.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.52,138.72a3.31,3.31,0,0,1-1.64.34,3.08,3.08,0,0,1-2.09-.65,2.54,2.54,0,0,1-.73-2v-1.65h-.88v-1.95h.88V131h2.67v1.8h1.32v1.95h-1.32v1.63a.65.65,0,0,0,.15.46.52.52,0,0,0,.4.16,1,1,0,0,0,.6-.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.61,133.09a3,3,0,0,1,.7,2.17v3.68h-2.67v-3.22q0-1.11-.72-1.11a.76.76,0,0,0-.61.29,1.42,1.42,0,0,0-.23.89v3.15h-2.66v-3.22q0-1.11-.72-1.11a.75.75,0,0,0-.61.29,1.42,1.42,0,0,0-.23.89v3.15h-2.67v-6.45h2.54v.6a2.48,2.48,0,0,1,1.83-.72,2.78,2.78,0,0,1,1.17.24,2.16,2.16,0,0,1,.85.74,2.66,2.66,0,0,1,.94-.72,2.9,2.9,0,0,1,1.22-.26A2.51,2.51,0,0,1,125.61,133.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.46,130.19h2.67v8.75h-2.67Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-29"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-29",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.42,
    y: 111.71,
    width: 220.92,
    height: 137.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.42,
    y: 111.71,
    width: 220.92,
    height: 137.1,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.77,
    y: 114.29,
    width: 216.21,
    height: 131.94,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.26,
    y: 248.82,
    width: 230.44,
    height: 3.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.26,
    y: 248.82,
    width: 230.44,
    height: 3.86,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.37,145.94a5.83,5.83,0,0,1-2.28-2.15,6.31,6.31,0,0,1,0-6.22,5.83,5.83,0,0,1,2.28-2.15,7.39,7.39,0,0,1,6.13-.2,5.4,5.4,0,0,1,2.12,1.62l-2.08,1.89a3.42,3.42,0,0,0-2.73-1.36,3.49,3.49,0,0,0-1.69.41A2.92,2.92,0,0,0,213,139a3.94,3.94,0,0,0,0,3.46,2.92,2.92,0,0,0,1.14,1.17,3.49,3.49,0,0,0,1.69.41,3.42,3.42,0,0,0,2.73-1.36l2.08,1.89a5.4,5.4,0,0,1-2.12,1.62,7.49,7.49,0,0,1-6.13-.2Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.37,145.93a5.91,5.91,0,0,1-2.3-2.16,5.77,5.77,0,0,1-.83-3.09,5.83,5.83,0,0,1,.83-3.1,6,6,0,0,1,2.3-2.15,7.39,7.39,0,0,1,6.61,0,6,6,0,0,1,2.3,2.15,5.83,5.83,0,0,1,.83,3.1,5.77,5.77,0,0,1-.83,3.09,5.91,5.91,0,0,1-2.3,2.16,7.48,7.48,0,0,1-6.61,0Zm4.89-2.35a3,3,0,0,0,1.13-1.17,3.85,3.85,0,0,0,0-3.46,3,3,0,0,0-1.13-1.17,3.27,3.27,0,0,0-3.17,0A3,3,0,0,0,225,139a3.85,3.85,0,0,0,0,3.46,3,3,0,0,0,1.13,1.17,3.27,3.27,0,0,0,3.17,0Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.84,134.89h5.48a7.58,7.58,0,0,1,3.37.71,5.37,5.37,0,0,1,2.29,2,6.18,6.18,0,0,1,0,6.12,5.37,5.37,0,0,1-2.29,2,7.58,7.58,0,0,1-3.37.71h-5.48Zm5.34,9a3.31,3.31,0,0,0,2.39-.85,3.44,3.44,0,0,0,0-4.66,3.31,3.31,0,0,0-2.39-.85h-2.07v6.36Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51,134.89h3.28v11.58h-3.28Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15,134.89v11.58h-2.7l-5.12-6.17v6.17h-3.21V134.89h2.7l5.11,6.17v-6.17Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.23,140.43h2.89v4.8a7.3,7.3,0,0,1-2.28,1.09,8.86,8.86,0,0,1-2.58.38,6.93,6.93,0,0,1-3.28-.76,6.08,6.08,0,0,1-2.28-8.37,5.69,5.69,0,0,1,2.3-2.15,7.1,7.1,0,0,1,3.32-.77,7.49,7.49,0,0,1,2.92.55,5.58,5.58,0,0,1,2.15,1.57l-2.09,1.89a3.67,3.67,0,0,0-2.81-1.29,3.28,3.28,0,0,0-2.4.9,3.23,3.23,0,0,0-.91,2.41,3.54,3.54,0,0,0,.41,1.71,2.93,2.93,0,0,0,1.16,1.18,3.44,3.44,0,0,0,1.71.42,4.23,4.23,0,0,0,1.77-.38Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.37,145.94a5.83,5.83,0,0,1-2.28-2.15,6.31,6.31,0,0,1,0-6.22,5.83,5.83,0,0,1,2.28-2.15,7.39,7.39,0,0,1,6.13-.2,5.4,5.4,0,0,1,2.12,1.62l-2.08,1.89a3.42,3.42,0,0,0-2.73-1.36,3.49,3.49,0,0,0-1.69.41A2.92,2.92,0,0,0,213,139a3.94,3.94,0,0,0,0,3.46,2.92,2.92,0,0,0,1.14,1.17,3.49,3.49,0,0,0,1.69.41,3.42,3.42,0,0,0,2.73-1.36l2.08,1.89a5.4,5.4,0,0,1-2.12,1.62,7.49,7.49,0,0,1-6.13-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.37,145.93a5.91,5.91,0,0,1-2.3-2.16,5.77,5.77,0,0,1-.83-3.09,5.83,5.83,0,0,1,.83-3.1,6,6,0,0,1,2.3-2.15,7.39,7.39,0,0,1,6.61,0,6,6,0,0,1,2.3,2.15,5.83,5.83,0,0,1,.83,3.1,5.77,5.77,0,0,1-.83,3.09,5.91,5.91,0,0,1-2.3,2.16,7.48,7.48,0,0,1-6.61,0Zm4.89-2.35a3,3,0,0,0,1.13-1.17,3.85,3.85,0,0,0,0-3.46,3,3,0,0,0-1.13-1.17,3.27,3.27,0,0,0-3.17,0A3,3,0,0,0,225,139a3.85,3.85,0,0,0,0,3.46,3,3,0,0,0,1.13,1.17,3.27,3.27,0,0,0,3.17,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.84,134.89h5.48a7.58,7.58,0,0,1,3.37.71,5.37,5.37,0,0,1,2.29,2,6.18,6.18,0,0,1,0,6.12,5.37,5.37,0,0,1-2.29,2,7.58,7.58,0,0,1-3.37.71h-5.48Zm5.34,9a3.31,3.31,0,0,0,2.39-.85,3.44,3.44,0,0,0,0-4.66,3.31,3.31,0,0,0-2.39-.85h-2.07v6.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51,134.89h3.28v11.58h-3.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15,134.89v11.58h-2.7l-5.12-6.17v6.17h-3.21V134.89h2.7l5.11,6.17v-6.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.23,140.43h2.89v4.8a7.3,7.3,0,0,1-2.28,1.09,8.86,8.86,0,0,1-2.58.38,6.93,6.93,0,0,1-3.28-.76,6.08,6.08,0,0,1-2.28-8.37,5.69,5.69,0,0,1,2.3-2.15,7.1,7.1,0,0,1,3.32-.77,7.49,7.49,0,0,1,2.92.55,5.58,5.58,0,0,1,2.15,1.57l-2.09,1.89a3.67,3.67,0,0,0-2.81-1.29,3.28,3.28,0,0,0-2.4.9,3.23,3.23,0,0,0-.91,2.41,3.54,3.54,0,0,0,.41,1.71,2.93,2.93,0,0,0,1.16,1.18,3.44,3.44,0,0,0,1.71.42,4.23,4.23,0,0,0,1.77-.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 157.5,
    width: 28.01,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 165.9,
    width: 68.96,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 173.1,
    width: 66.94,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 180.3,
    width: 73.69,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 187.5,
    width: 67.39,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 194.7,
    width: 67.39,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 201.9,
    width: 71.46,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.14,212.7H271a1.76,1.76,0,0,1-1.76-1.76h0a1.76,1.76,0,0,1,1.76-1.76h55.19a1.76,1.76,0,0,1,1.76,1.76h0A1.76,1.76,0,0,1,326.14,212.7Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 157.5,
    width: 28.01,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 165.9,
    width: 68.96,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 173.1,
    width: 66.94,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 180.3,
    width: 73.69,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 187.5,
    width: 67.39,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 194.7,
    width: 67.39,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 201.9,
    width: 71.46,
    height: 3.6,
    rx: 1.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.14,212.7H271a1.76,1.76,0,0,1-1.76-1.76h0a1.76,1.76,0,0,1,1.76-1.76h55.19a1.76,1.76,0,0,1,1.76,1.76h0A1.76,1.76,0,0,1,326.14,212.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.58,203.76c18.22-2.19,36.64-4.23,55.13-4.78,3.63-.11,7.27-.14,10.9,0,0,0,0-1.78,0-1.78-16-.4-32.05,1.15-47.8,2.78q-9.13.94-18.23,2c-.16,0,.11,1.76,0,1.78Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.33,207.21c11.53-2.27,23.19-4.37,34.89-4.94,2.3-.11,4.6-.15,6.9-.06,0,0,0-1.84,0-1.84-10.09-.41-20.28,1.19-30.25,2.88q-5.77,1-11.54,2.12c-.1,0,.07,1.83,0,1.84Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7,122.43,219,130H216.4L215,125.9,213.48,130H210.9l-2.71-7.61h2.52l1.56,4.6,1.62-4.6h2.28l1.57,4.65,1.61-4.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.92,129.66a3.73,3.73,0,0,1-2.09-3.44,3.74,3.74,0,0,1,2.08-3.42,5.16,5.16,0,0,1,4.43,0,3.71,3.71,0,0,1,1.54,1.39,3.83,3.83,0,0,1,.54,2,3.89,3.89,0,0,1-.54,2,3.8,3.8,0,0,1-1.54,1.4,5,5,0,0,1-4.42,0Zm3.36-2.1a1.89,1.89,0,0,0,.45-1.34,1.85,1.85,0,0,0-.45-1.32,1.63,1.63,0,0,0-2.31,0,1.85,1.85,0,0,0-.45,1.32,1.89,1.89,0,0,0,.45,1.34,1.63,1.63,0,0,0,2.31,0Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.26,122.56a4.14,4.14,0,0,1,1.5-.26v2.4a5,5,0,0,0-.61,0,1.86,1.86,0,0,0-1.34.46,1.89,1.89,0,0,0-.48,1.42V130h-2.67v-7.61h2.54v.91A2.45,2.45,0,0,1,235.26,122.56Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.31,127.37l-.79.8V130h-2.67V119.62h2.67v5.46l2.73-2.65h3.16l-3.16,3.25,3.43,4.36h-3.23Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11,130a5.15,5.15,0,0,1-1.49-.57l.8-1.83a4.54,4.54,0,0,0,1.24.52,5.77,5.77,0,0,0,1.42.19,2.26,2.26,0,0,0,.92-.14.42.42,0,0,0,.27-.38q0-.26-.33-.36a7.27,7.27,0,0,0-1.05-.21,10,10,0,0,1-1.55-.29,2.4,2.4,0,0,1-1.1-.68,1.89,1.89,0,0,1-.46-1.37,2.07,2.07,0,0,1,.43-1.3,2.86,2.86,0,0,1,1.27-.9,5.48,5.48,0,0,1,2-.33,8.32,8.32,0,0,1,1.65.17,4.6,4.6,0,0,1,1.36.48l-.8,1.81a4.38,4.38,0,0,0-2.19-.56,2.21,2.21,0,0,0-.93.14.43.43,0,0,0-.29.39c0,.18.1.3.32.37a7.88,7.88,0,0,0,1.07.22,12.07,12.07,0,0,1,1.56.32,2.37,2.37,0,0,1,1.07.67,1.91,1.91,0,0,1,.46,1.36,2.07,2.07,0,0,1-.44,1.28,2.8,2.8,0,0,1-1.28.89,5.68,5.68,0,0,1-2,.33A8.47,8.47,0,0,1,248.11,130Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.15,123.14a3.38,3.38,0,0,1,.86,2.54V130h-2.66v-3.92c0-1-.42-1.56-1.25-1.56A1.45,1.45,0,0,0,258,125a2,2,0,0,0-.41,1.35V130h-2.67V119.62h2.67v3.51a2.94,2.94,0,0,1,1-.62,3.8,3.8,0,0,1,1.27-.21A3.14,3.14,0,0,1,262.15,123.14Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.41,129.66a3.78,3.78,0,0,1-2.09-3.44,3.78,3.78,0,0,1,2.09-3.42,4.83,4.83,0,0,1,2.21-.5,4.9,4.9,0,0,1,2.22.5,3.68,3.68,0,0,1,1.53,1.39,3.74,3.74,0,0,1,.55,2,3.75,3.75,0,0,1-2.08,3.44,5.07,5.07,0,0,1-4.43,0Zm3.36-2.1a1.89,1.89,0,0,0,.45-1.34,1.85,1.85,0,0,0-.45-1.32,1.62,1.62,0,0,0-2.3,0,1.85,1.85,0,0,0-.45,1.32,1.89,1.89,0,0,0,.45,1.34,1.62,1.62,0,0,0,2.3,0Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.83,122.78a3.58,3.58,0,0,1,1.35,1.38,4.12,4.12,0,0,1,.5,2.07,4.07,4.07,0,0,1-.5,2.07,3.45,3.45,0,0,1-1.35,1.38,3.74,3.74,0,0,1-1.88.49,2.85,2.85,0,0,1-2.13-.81v3.41h-2.67V122.43h2.55v.75a2.76,2.76,0,0,1,2.25-.88A3.73,3.73,0,0,1,280.83,122.78Zm-1.29,4.78a2.23,2.23,0,0,0,0-2.66,1.52,1.52,0,0,0-1.16-.48,1.5,1.5,0,0,0-1.15.48,2.19,2.19,0,0,0,0,2.66,1.5,1.5,0,0,0,1.15.48A1.52,1.52,0,0,0,279.54,127.56Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.7,122.43,219,130H216.4L215,125.9,213.48,130H210.9l-2.71-7.61h2.52l1.56,4.6,1.62-4.6h2.28l1.57,4.65,1.61-4.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.92,129.66a3.73,3.73,0,0,1-2.09-3.44,3.74,3.74,0,0,1,2.08-3.42,5.16,5.16,0,0,1,4.43,0,3.71,3.71,0,0,1,1.54,1.39,3.83,3.83,0,0,1,.54,2,3.89,3.89,0,0,1-.54,2,3.8,3.8,0,0,1-1.54,1.4,5,5,0,0,1-4.42,0Zm3.36-2.1a1.89,1.89,0,0,0,.45-1.34,1.85,1.85,0,0,0-.45-1.32,1.63,1.63,0,0,0-2.31,0,1.85,1.85,0,0,0-.45,1.32,1.89,1.89,0,0,0,.45,1.34,1.63,1.63,0,0,0,2.31,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.26,122.56a4.14,4.14,0,0,1,1.5-.26v2.4a5,5,0,0,0-.61,0,1.86,1.86,0,0,0-1.34.46,1.89,1.89,0,0,0-.48,1.42V130h-2.67v-7.61h2.54v.91A2.45,2.45,0,0,1,235.26,122.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.31,127.37l-.79.8V130h-2.67V119.62h2.67v5.46l2.73-2.65h3.16l-3.16,3.25,3.43,4.36h-3.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11,130a5.15,5.15,0,0,1-1.49-.57l.8-1.83a4.54,4.54,0,0,0,1.24.52,5.77,5.77,0,0,0,1.42.19,2.26,2.26,0,0,0,.92-.14.42.42,0,0,0,.27-.38q0-.26-.33-.36a7.27,7.27,0,0,0-1.05-.21,10,10,0,0,1-1.55-.29,2.4,2.4,0,0,1-1.1-.68,1.89,1.89,0,0,1-.46-1.37,2.07,2.07,0,0,1,.43-1.3,2.86,2.86,0,0,1,1.27-.9,5.48,5.48,0,0,1,2-.33,8.32,8.32,0,0,1,1.65.17,4.6,4.6,0,0,1,1.36.48l-.8,1.81a4.38,4.38,0,0,0-2.19-.56,2.21,2.21,0,0,0-.93.14.43.43,0,0,0-.29.39c0,.18.1.3.32.37a7.88,7.88,0,0,0,1.07.22,12.07,12.07,0,0,1,1.56.32,2.37,2.37,0,0,1,1.07.67,1.91,1.91,0,0,1,.46,1.36,2.07,2.07,0,0,1-.44,1.28,2.8,2.8,0,0,1-1.28.89,5.68,5.68,0,0,1-2,.33A8.47,8.47,0,0,1,248.11,130Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.15,123.14a3.38,3.38,0,0,1,.86,2.54V130h-2.66v-3.92c0-1-.42-1.56-1.25-1.56A1.45,1.45,0,0,0,258,125a2,2,0,0,0-.41,1.35V130h-2.67V119.62h2.67v3.51a2.94,2.94,0,0,1,1-.62,3.8,3.8,0,0,1,1.27-.21A3.14,3.14,0,0,1,262.15,123.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.41,129.66a3.78,3.78,0,0,1-2.09-3.44,3.78,3.78,0,0,1,2.09-3.42,4.83,4.83,0,0,1,2.21-.5,4.9,4.9,0,0,1,2.22.5,3.68,3.68,0,0,1,1.53,1.39,3.74,3.74,0,0,1,.55,2,3.75,3.75,0,0,1-2.08,3.44,5.07,5.07,0,0,1-4.43,0Zm3.36-2.1a1.89,1.89,0,0,0,.45-1.34,1.85,1.85,0,0,0-.45-1.32,1.62,1.62,0,0,0-2.3,0,1.85,1.85,0,0,0-.45,1.32,1.89,1.89,0,0,0,.45,1.34,1.62,1.62,0,0,0,2.3,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.83,122.78a3.58,3.58,0,0,1,1.35,1.38,4.12,4.12,0,0,1,.5,2.07,4.07,4.07,0,0,1-.5,2.07,3.45,3.45,0,0,1-1.35,1.38,3.74,3.74,0,0,1-1.88.49,2.85,2.85,0,0,1-2.13-.81v3.41h-2.67V122.43h2.55v.75a2.76,2.76,0,0,1,2.25-.88A3.73,3.73,0,0,1,280.83,122.78Zm-1.29,4.78a2.23,2.23,0,0,0,0-2.66,1.52,1.52,0,0,0-1.16-.48,1.5,1.5,0,0,0-1.15.48,2.19,2.19,0,0,0,0,2.66,1.5,1.5,0,0,0,1.15.48A1.52,1.52,0,0,0,279.54,127.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156,155.88l-1.75.64,1.75.64v.66l-2.5-.95v-.69l2.5-1Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.91,153.94h.73l-1.73,4.95h-.73Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.24,156.18v.69l-2.5.95v-.66l1.75-.64-1.75-.64v-.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.87,163.39h-7.15a.66.66,0,0,1,0-1.31h7.15a.66.66,0,1,1,0,1.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.87,167.68h-7.15a.66.66,0,0,1,0-1.31h7.15a.66.66,0,1,1,0,1.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.87,172h-7.15a.66.66,0,0,1,0-1.31h7.15a.66.66,0,1,1,0,1.31Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.87,176.26h-7.15a.66.66,0,0,1,0-1.31h7.15a.66.66,0,1,1,0,1.31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.87,180.55h-7.15a.66.66,0,0,1,0-1.32h7.15a.66.66,0,0,1,0,1.32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.87,184.84h-7.15a.66.66,0,0,1,0-1.32h7.15a.66.66,0,0,1,0,1.32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.87,189.13h-7.15a.66.66,0,0,1,0-1.32h7.15a.66.66,0,0,1,0,1.32Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.87,193.42h-7.15a.66.66,0,0,1,0-1.32h7.15a.66.66,0,0,1,0,1.32Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.87,197.7h-7.15a.66.66,0,0,1,0-1.31h7.15a.66.66,0,1,1,0,1.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.54,184.76H166.87a.66.66,0,0,1,0-1.31h14.67a.66.66,0,0,1,0,1.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.54,163.39H166.87a.66.66,0,0,1,0-1.31h14.67a.66.66,0,0,1,0,1.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,184.76H185.44a.66.66,0,1,1,0-1.31h38.21a.66.66,0,1,1,0,1.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.4,167.68H217.33a.66.66,0,1,1,0-1.31H228.4a.66.66,0,1,1,0,1.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.55,188.47h-22.7a.66.66,0,1,1,0-1.32h22.7a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.58,188.47H196.22a.66.66,0,0,1,0-1.32h22.36a.66.66,0,1,1,0,1.32Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.35,188.47H222.22a.66.66,0,1,1,0-1.32h24.13a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.65,192.76H180a.66.66,0,0,1,0-1.32h13.63a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.94,192.76H198.07a.66.66,0,0,1,0-1.32h14.87a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.43,192.76H216.32a.66.66,0,0,1,0-1.32h24.11a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.17,167.68H168.85a.66.66,0,1,1,0-1.31h18.32a.66.66,0,1,1,0,1.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.47,172H168.85a.66.66,0,1,1,0-1.31h20.62a.66.66,0,0,1,0,1.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.91,172H192.84a.66.66,0,0,1,0-1.31h31.07a.66.66,0,1,1,0,1.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.66,163.39H211.6a.66.66,0,1,1,0-1.31h31.06a.66.66,0,1,1,0,1.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.35,172H227.68a.66.66,0,1,1,0-1.31h18.67a.66.66,0,0,1,0,1.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.23,176.26H175.42a.66.66,0,0,1,0-1.32h11.81a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.9,176.26H191.25a.66.66,0,0,1,0-1.32H213.9a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.89,163.39H185.24a.66.66,0,0,1,0-1.31h22.65a.66.66,0,1,1,0,1.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.43,176.26H218.32a.66.66,0,0,1,0-1.32h22.11a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.63,167.68H191.52a.66.66,0,0,1,0-1.31h22.11a.66.66,0,1,1,0,1.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.91,180.55H182a.66.66,0,0,1,0-1.32h13.91a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212,180.55H198.77a.66.66,0,0,1,0-1.32H212a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.43,180.55H216.19a.66.66,0,0,1,0-1.32h24.24a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199,197.05H182a.66.66,0,0,1,0-1.32h17a.66.66,0,0,1,0,1.32Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tabs--inject-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.64,
    y: 145.26,
    width: 13.13,
    height: 9.48,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.35,
    y: 149.1,
    width: 73.42,
    height: 53.15,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.35,
    y: 149.1,
    width: 73.42,
    height: 53.15,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.35,
    y: 149.1,
    width: 10.23,
    height: 53.15,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.35,
    y: 148.98,
    width: 73.42,
    height: 4.97,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.61,
    cy: 147.68,
    r: 1.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.01,
    cy: 147.68,
    r: 1.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.41,
    cy: 147.68,
    r: 1.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.34,173.36a3.38,3.38,0,0,1-1.36-1l1.43-1.69a2.06,2.06,0,0,0,1.6,1,1.09,1.09,0,0,0,.87-.34,1.5,1.5,0,0,0,.3-1v-4H97v-2h5.8v5.85a3.67,3.67,0,0,1-.9,2.7,3.62,3.62,0,0,1-2.67.91A4.67,4.67,0,0,1,97.34,173.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.56,171.73h-3.92l-.73,1.8h-2.67l4.09-9.27h2.58l4.11,9.27h-2.73Zm-.77-1.93-1.19-3-1.19,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64,164.26l-4,9.27h-2.58l-4-9.27H116l2.52,6,2.57-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,171.73h-3.92l-.73,1.8h-2.67l4.09-9.27h2.58l4.11,9.27h-2.73Zm-.77-1.93-1.19-3-1.19,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,189.33a5.39,5.39,0,0,1-1.72-.74l.86-1.94a5.32,5.32,0,0,0,1.44.67,5.8,5.8,0,0,0,1.62.25c1,0,1.5-.25,1.5-.76a.63.63,0,0,0-.43-.59,8.22,8.22,0,0,0-1.38-.4,13.6,13.6,0,0,1-1.75-.48,3,3,0,0,1-1.2-.83A2.22,2.22,0,0,1,94.4,183a2.68,2.68,0,0,1,.47-1.53,3.19,3.19,0,0,1,1.38-1.08,5.83,5.83,0,0,1,2.26-.39,7.76,7.76,0,0,1,1.8.2,5.76,5.76,0,0,1,1.56.6l-.8,1.95A5.37,5.37,0,0,0,98.5,182a2.11,2.11,0,0,0-1.14.23.68.68,0,0,0-.36.6.6.6,0,0,0,.42.56,8.06,8.06,0,0,0,1.37.38,13.16,13.16,0,0,1,1.75.48,3.14,3.14,0,0,1,1.21.82,2.21,2.21,0,0,1,.51,1.53,2.6,2.6,0,0,1-.47,1.51,3.1,3.1,0,0,1-1.39,1.08,5.58,5.58,0,0,1-2.25.41A8.74,8.74,0,0,1,96,189.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.88,189.06a3.47,3.47,0,0,1-1.46-1.32,3.6,3.6,0,0,1-.53-1.92,3.54,3.54,0,0,1,2-3.23,4.76,4.76,0,0,1,2.13-.47,4.11,4.11,0,0,1,2.11.53,2.85,2.85,0,0,1,1.25,1.45l-1.94,1a1.56,1.56,0,0,0-1.43-1,1.5,1.5,0,0,0-1.12.45,2,2,0,0,0,0,2.51,1.47,1.47,0,0,0,1.12.46,1.55,1.55,0,0,0,1.43-1l1.94,1a2.85,2.85,0,0,1-1.25,1.45,4.1,4.1,0,0,1-2.11.52A4.64,4.64,0,0,1,104.88,189.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.73,182.37a3.85,3.85,0,0,1,1.41-.25v2.27a4.43,4.43,0,0,0-.57,0,1.74,1.74,0,0,0-1.27.44,1.77,1.77,0,0,0-.46,1.33v3.3h-2.51v-7.18h2.39v.86A2.36,2.36,0,0,1,114.73,182.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.31,181.07a1.26,1.26,0,0,1-.42-1,1.22,1.22,0,0,1,.42-1,1.61,1.61,0,0,1,1.12-.39,1.65,1.65,0,0,1,1.11.37,1.17,1.17,0,0,1,.42.93,1.29,1.29,0,0,1-.42,1,1.57,1.57,0,0,1-1.11.39A1.65,1.65,0,0,1,117.31,181.07Zm-.14,1.17h2.51v7.18h-2.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.61,182.58a3.38,3.38,0,0,1,1.27,1.3,4.3,4.3,0,0,1,0,3.91,3.28,3.28,0,0,1-1.27,1.29,3.47,3.47,0,0,1-1.78.46,2.68,2.68,0,0,1-2-.75V192h-2.52v-9.75h2.4V183a2.6,2.6,0,0,1,2.12-.84A3.57,3.57,0,0,1,127.61,182.58Zm-1.22,4.5a2.07,2.07,0,0,0,0-2.5,1.52,1.52,0,0,0-2.18,0,2.07,2.07,0,0,0,0,2.5,1.52,1.52,0,0,0,2.18,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.47,189.13a2.54,2.54,0,0,1-.78.3,3.74,3.74,0,0,1-1,.11,3.11,3.11,0,0,1-2.16-.69,2.64,2.64,0,0,1-.75-2v-2.41h-1.05v-1.88h1.05v-1.87h2.51v1.87H135v1.88h-1.65v2.38a.85.85,0,0,0,.21.61.74.74,0,0,0,.55.21,1.34,1.34,0,0,0,.77-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.09,
    y: 81.3,
    width: 11.65,
    height: 8.41,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.62,
    y: 84.7,
    width: 65.12,
    height: 47.14,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.62,
    y: 84.7,
    width: 65.12,
    height: 47.14,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.62,
    y: 84.7,
    width: 9.07,
    height: 47.14,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.62,
    y: 84.6,
    width: 65.12,
    height: 4.41,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,83.45a.91.91,0,0,0,1.82,0,.91.91,0,1,0-1.82,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.83,83.45a.92.92,0,1,0,.92-.91A.91.91,0,0,0,181.83,83.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.64,83.45a.92.92,0,1,0,.91-.91A.91.91,0,0,0,178.64,83.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.81,105.5l-3.71,1.32,3.71,1.31v1.7l-5.73-2.12v-1.79l5.73-2.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.19,105.18a2.78,2.78,0,0,1,.72,2.1v3.61H150.7v-3.25c0-.86-.35-1.29-1-1.29a1.2,1.2,0,0,0-.91.37,1.61,1.61,0,0,0-.34,1.12v3H146.2v-8.63h2.21v2.91a2.38,2.38,0,0,1,.85-.52,3.19,3.19,0,0,1,1-.17A2.55,2.55,0,0,1,152.19,105.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.8,108.3h-4.59a1.38,1.38,0,0,0,.54.75,1.87,1.87,0,0,0,1,.26,2.38,2.38,0,0,0,.79-.13,2.43,2.43,0,0,0,.66-.42l1.17,1.21a3.43,3.43,0,0,1-2.69,1,4.26,4.26,0,0,1-1.94-.42,3.06,3.06,0,0,1-1.3-1.16,3.19,3.19,0,0,1,1.23-4.51,4,4,0,0,1,3.49,0,2.93,2.93,0,0,1,1.21,1.13,3.28,3.28,0,0,1,.45,1.75S160.82,108,160.8,108.3Zm-4.19-2a1.37,1.37,0,0,0-.43.79h2.58a1.33,1.33,0,0,0-.44-.79,1.27,1.27,0,0,0-.85-.29A1.31,1.31,0,0,0,156.61,106.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.76,105.2a2.73,2.73,0,0,1,.83,2.19v3.5h-2.06v-.81a1.9,1.9,0,0,1-1.86.91,2.94,2.94,0,0,1-1.27-.25,2,2,0,0,1-.81-.69,1.87,1.87,0,0,1-.27-1,1.61,1.61,0,0,1,.69-1.39,3.61,3.61,0,0,1,2.11-.49h1.26c0-.67-.48-1-1.34-1a3.32,3.32,0,0,0-.92.14,2.55,2.55,0,0,0-.79.4l-.74-1.5a4.23,4.23,0,0,1,1.27-.54,6,6,0,0,1,1.51-.19A3.54,3.54,0,0,1,166.76,105.2Zm-1.8,4.21a1,1,0,0,0,.42-.54v-.55h-.95c-.65,0-1,.21-1,.64a.54.54,0,0,0,.22.46.94.94,0,0,0,.61.18A1.17,1.17,0,0,0,165,109.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.78,102.26v8.63h-2.11v-.63a2.26,2.26,0,0,1-1.85.73,3.14,3.14,0,0,1-1.57-.4,2.92,2.92,0,0,1-1.12-1.14,3.56,3.56,0,0,1-.41-1.72,3.5,3.5,0,0,1,.41-1.72,2.9,2.9,0,0,1,1.12-1.13,3.14,3.14,0,0,1,1.57-.4,2.3,2.3,0,0,1,1.75.65v-2.87Zm-2.55,6.58a1.57,1.57,0,0,0,.37-1.11,1.58,1.58,0,0,0-.36-1.1,1.25,1.25,0,0,0-1-.39,1.24,1.24,0,0,0-.95.39,1.55,1.55,0,0,0-.38,1.1,1.57,1.57,0,0,0,.38,1.11,1.32,1.32,0,0,0,1.89,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.9,105.92v1.79l-5.74,2.12v-1.7l3.71-1.31-3.71-1.32v-1.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.45,
    y: 224.75,
    width: 7.42,
    height: 5.36,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.36,
    y: 226.92,
    width: 41.51,
    height: 30.05,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.36,
    y: 226.92,
    width: 41.51,
    height: 30.05,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.36,
    y: 226.92,
    width: 5.78,
    height: 30.05,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.36,
    y: 226.86,
    width: 41.51,
    height: 2.81,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.08,
    cy: 226.12,
    r: 0.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.05,
    cy: 226.12,
    r: 0.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.02,
    cy: 226.12,
    r: 0.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.42,240.36l-2,.7,2,.69v.9l-3-1.12v-.95l3-1.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.21,238.9h2a2.78,2.78,0,0,1,1.26.27,1.89,1.89,0,0,1,.85.75,2.11,2.11,0,0,1,.3,1.14,2.16,2.16,0,0,1-.3,1.14,2,2,0,0,1-.85.75,2.92,2.92,0,0,1-1.26.26h-2Zm2,3.34a1.28,1.28,0,0,0,.89-.32,1.11,1.11,0,0,0,.33-.86,1.15,1.15,0,0,0-.33-.87,1.28,1.28,0,0,0-.89-.32h-.77v2.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.29,238.9h1.22v4.31h-1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.74,238.9l-1.85,4.31h-1.2l-1.84-4.31h1.32l1.17,2.81,1.19-2.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.05,240.58v.95l-3,1.12v-.9l2-.69-2-.7v-.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.36,
    y: 75.95,
    width: 14.91,
    height: 10.76,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 80.3,
    width: 83.36,
    height: 60.34,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 80.3,
    width: 83.36,
    height: 60.34,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 80.3,
    width: 11.61,
    height: 60.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 80.17,
    width: 83.36,
    height: 5.64,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.67,
    cy: 78.7,
    r: 1.17,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.59,
    cy: 78.7,
    r: 1.17,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.5,
    cy: 78.7,
    r: 1.17,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.82,105.21a5.57,5.57,0,0,1,0,10.24,9.08,9.08,0,0,1-3.72.71h-2.76v4.13h-4.46V104.5h7.22A9.08,9.08,0,0,1,335.82,105.21ZM333.9,112a2.08,2.08,0,0,0,.7-1.7,2.12,2.12,0,0,0-.7-1.71,3.06,3.06,0,0,0-2.07-.61h-2.49v4.62h2.49A3.12,3.12,0,0,0,333.9,112Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.3,104.5v15.79h-4.47v-6.16h-6.09v6.16h-4.46V104.5h4.46v5.93h6.09V104.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,105.21a5.48,5.48,0,0,1,2.43,2,5.57,5.57,0,0,1,.86,3.1,5.34,5.34,0,0,1-3.29,5.11,9.11,9.11,0,0,1-3.72.71h-2.76v4.13h-4.46V104.5h7.22A9.11,9.11,0,0,1,370.4,105.21ZM368.48,112a2.08,2.08,0,0,0,.7-1.7,2.12,2.12,0,0,0-.7-1.71,3.08,3.08,0,0,0-2.08-.61h-2.48v4.62h2.48A3.13,3.13,0,0,0,368.48,112Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tables--inject-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "229.64 417.31 227.17 417.31 224 311.47 227.26 311.47 229.64 417.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.64 417.31 227.17 417.31 224 311.47 227.26 311.47 229.64 417.31",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.87 311.47 189.87 417.31 192.48 417.31 195.55 316.31 227.05 316.31 229.35 417.31 231.94 417.31 231.94 311.47 189.87 311.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.87 311.47 189.87 417.31 192.48 417.31 195.55 316.31 227.05 316.31 229.35 417.31 231.94 417.31 231.94 311.47 189.87 311.47",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.87 417.31 187.4 417.31 186.61 311.47 189.87 311.47 189.87 417.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.87 417.31 187.4 417.31 186.61 311.47 189.87 311.47 189.87 417.31",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.15 417.31 139.68 417.31 136.5 311.47 139.76 311.47 142.15 417.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.15 417.31 139.68 417.31 136.5 311.47 139.76 311.47 142.15 417.31",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.37 311.47 102.37 417.31 104.98 417.31 108.06 316.31 139.56 316.31 141.86 417.31 144.44 417.31 144.44 311.47 102.37 311.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.37 311.47 102.37 417.31 104.98 417.31 108.06 316.31 139.56 316.31 141.86 417.31 144.44 417.31 144.44 311.47 102.37 311.47",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.37 417.31 99.91 417.31 99.11 311.47 102.37 311.47 102.37 417.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.37 417.31 99.91 417.31 99.11 311.47 102.37 311.47 102.37 417.31",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.8,
    y: 305.39,
    width: 93.04,
    height: 6.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.8,
    y: 305.39,
    width: 93.04,
    height: 6.09,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.04,
    y: 305.39,
    width: 52.21,
    height: 6.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.04,
    y: 305.39,
    width: 52.21,
    height: 6.09,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.43 416.8 354.96 416.8 351.79 310.97 355.05 310.97 357.43 416.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.43 416.8 354.96 416.8 351.79 310.97 355.05 310.97 357.43 416.8",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.66 310.97 317.66 416.8 320.27 416.8 323.34 315.8 354.84 315.8 357.14 416.8 359.73 416.8 359.73 310.97 317.66 310.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.66 310.97 317.66 416.8 320.27 416.8 323.34 315.8 354.84 315.8 357.14 416.8 359.73 416.8 359.73 310.97 317.66 310.97",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.66 416.8 315.19 416.8 314.4 310.97 317.66 310.97 317.66 416.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.66 416.8 315.19 416.8 314.4 310.97 317.66 310.97 317.66 416.8",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.93 416.8 267.47 416.8 264.29 310.97 267.55 310.97 269.93 416.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.93 416.8 267.47 416.8 264.29 310.97 267.55 310.97 269.93 416.8",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.16 310.97 230.16 416.8 232.77 416.8 235.84 315.8 267.34 315.8 269.65 416.8 272.23 416.8 272.23 310.97 230.16 310.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.16 310.97 230.16 416.8 232.77 416.8 235.84 315.8 267.34 315.8 269.65 416.8 272.23 416.8 272.23 310.97 230.16 310.97",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.16 416.8 227.7 416.8 226.9 310.97 230.16 310.97 230.16 416.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.16 416.8 227.7 416.8 226.9 310.97 230.16 310.97 230.16 416.8",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.59,
    y: 304.88,
    width: 93.04,
    height: 6.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.59,
    y: 304.88,
    width: 93.04,
    height: 6.09,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.83,
    y: 304.88,
    width: 52.21,
    height: 6.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.83,
    y: 304.88,
    width: 52.21,
    height: 6.09,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.3,304.93h32.5a1.84,1.84,0,0,0,1.77-1.55L172.85,280a1.32,1.32,0,0,0-1.33-1.56H139a1.86,1.86,0,0,0-1.78,1.56L134,303.38A1.32,1.32,0,0,0,135.3,304.93Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.3,304.93h32.5a1.84,1.84,0,0,0,1.77-1.55L172.85,280a1.32,1.32,0,0,0-1.33-1.56H139a1.86,1.86,0,0,0-1.78,1.56L134,303.38A1.32,1.32,0,0,0,135.3,304.93Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.48,301.45l28.88-.14a1.71,1.71,0,0,0,1.64-1.43l2.56-17.62a1.21,1.21,0,0,0-1.23-1.43l-28.88.13a1.7,1.7,0,0,0-1.63,1.43L136.25,300A1.22,1.22,0,0,0,137.48,301.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.48,301.45l28.88-.14a1.71,1.71,0,0,0,1.64-1.43l2.56-17.62a1.21,1.21,0,0,0-1.23-1.43l-28.88.13a1.7,1.7,0,0,0-1.63,1.43L136.25,300A1.22,1.22,0,0,0,137.48,301.45Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.23,283.31l-.52.19.52.18v.2l-.74-.28v-.21l.74-.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.79,282.73H142l-.51,1.47h-.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.77,283.39v.21l-.74.28v-.2l.52-.18-.52-.19v-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.42,285.53h-2.13a.19.19,0,0,1-.19-.19.2.2,0,0,1,.19-.2h2.13a.2.2,0,0,1,.19.2A.19.19,0,0,1,142.42,285.53Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.21,286.81h-2.12a.2.2,0,0,1-.19-.2.19.19,0,0,1,.19-.19h2.12a.19.19,0,0,1,.2.19A.2.2,0,0,1,142.21,286.81Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.09,288.08H140a.2.2,0,0,1-.19-.2.2.2,0,0,1,.19-.19h2.12a.2.2,0,1,1,0,.39Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.84,289.35h-2.12a.19.19,0,0,1-.19-.19.19.19,0,0,1,.19-.2h2.12a.2.2,0,1,1,0,.39Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M141.68,290.62h-2.12a.19.19,0,0,1-.2-.19.2.2,0,0,1,.2-.2h2.12a.19.19,0,0,1,.19.2A.18.18,0,0,1,141.68,290.62Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.45,291.9h-2.12a.2.2,0,0,1-.19-.2.19.19,0,0,1,.19-.19h2.12a.19.19,0,0,1,.2.19A.2.2,0,0,1,141.45,291.9Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141.26,293.17h-2.12a.2.2,0,0,1-.2-.2.19.19,0,0,1,.2-.19h2.12a.18.18,0,0,1,.19.19A.19.19,0,0,1,141.26,293.17Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M141,294.44H138.9a.2.2,0,1,1,0-.39H141a.19.19,0,0,1,.19.2A.19.19,0,0,1,141,294.44Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M140.78,295.71h-2.12a.18.18,0,0,1-.19-.19.19.19,0,0,1,.19-.2h2.12a.2.2,0,0,1,.2.2A.19.19,0,0,1,140.78,295.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M148.55,285.53H144.2a.19.19,0,0,1-.2-.19.2.2,0,0,1,.2-.2h4.35a.2.2,0,0,1,.19.2A.19.19,0,0,1,148.55,285.53Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,285.53H149.7a.19.19,0,0,1-.19-.19.2.2,0,0,1,.19-.2H161a.19.19,0,0,1,.19.2A.18.18,0,0,1,161,285.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.21,285.53h-3.28a.19.19,0,0,1-.2-.19.2.2,0,0,1,.2-.2h3.28a.2.2,0,0,1,.2.2A.19.19,0,0,1,166.21,285.53Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.94,286.81H144.58a.2.2,0,0,1-.2-.2.19.19,0,0,1,.2-.19h11.36a.19.19,0,0,1,.2.19A.2.2,0,0,1,155.94,286.81Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.57,286.81H157a.19.19,0,0,1-.19-.2.18.18,0,0,1,.19-.19h10.59a.19.19,0,0,1,.2.19A.2.2,0,0,1,167.57,286.81Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,288.08h-6.73a.2.2,0,1,1,0-.39h6.73a.2.2,0,1,1,0,.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.21,288.08h-6.63a.19.19,0,0,1-.19-.2.19.19,0,0,1,.19-.19h6.63a.2.2,0,1,1,0,.39Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.45,288.08h-7.16a.2.2,0,0,1-.19-.2.2.2,0,0,1,.19-.19h7.16a.2.2,0,1,1,0,.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.57,289.35h-4a.2.2,0,0,1-.19-.19.2.2,0,0,1,.19-.2h4a.2.2,0,0,1,.19.2A.2.2,0,0,1,151.57,289.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.29,289.35h-4.41a.2.2,0,1,1,0-.39h4.41a.19.19,0,0,1,.19.2A.19.19,0,0,1,157.29,289.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.44,289.35h-7.15a.19.19,0,0,1-.19-.19.19.19,0,0,1,.19-.2h7.15a.2.2,0,1,1,0,.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.48,290.62h-5.43a.19.19,0,0,1-.2-.19.2.2,0,0,1,.2-.2h5.43a.2.2,0,0,1,.2.2A.19.19,0,0,1,149.48,290.62Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.94,291.9h-6.12a.19.19,0,0,1-.19-.2.18.18,0,0,1,.19-.19h6.12a.18.18,0,0,1,.19.19A.19.19,0,0,1,149.94,291.9Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.16,291.9h-9.22c1.1,0,1-.09,1-.2a.19.19,0,0,1,.2-.19h9.22a.19.19,0,0,1,.19.19C161.56,291.81,161.47,291.9,160.16,291.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,291.9h-5.54a.2.2,0,0,1-.19-.2.19.19,0,0,1,.19-.19h5.54a.19.19,0,0,1,.2.19A.2.2,0,0,1,166.81,291.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.08,293.17h-3.51a.2.2,0,0,1-.19-.2.19.19,0,0,1,.19-.19h3.51a.19.19,0,0,1,.19.19A.2.2,0,0,1,149.08,293.17Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157,293.17h-6.72a.19.19,0,0,1-.19-.2.18.18,0,0,1,.19-.19H157a.18.18,0,0,1,.19.19A.19.19,0,0,1,157,293.17Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.86,293.17H158.3c1.3,0,1.21-.09,1.21-.2a.19.19,0,0,1,.2-.19h6.56a.19.19,0,0,1,.19.19C166.46,293.08,166.37,293.17,164.86,293.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.41,294.44h-4.12a.2.2,0,1,1,0-.39h4.12a.2.2,0,1,1,0,.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.2,294.44h-3.94a.2.2,0,0,1-.19-.19.2.2,0,0,1,.19-.2h3.94a.2.2,0,0,1,.19.2A.2.2,0,0,1,156.2,294.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.62,294.44h-7.19a.19.19,0,0,1-.19-.19.19.19,0,0,1,.19-.2h7.19a.2.2,0,1,1,0,.39Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.1,295.71h-5a.19.19,0,0,1-.2-.19.2.2,0,0,1,.2-.2h5a.2.2,0,0,1,.19.2A.19.19,0,0,1,152.1,295.71Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "143.74 280.96 140.66 301.45 137.23 301.45 140.71 280.96 143.74 280.96",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.64,304.83H155a1.09,1.09,0,0,0,1.09-1.09h0a1.09,1.09,0,0,0-1.09-1.1H115.64a1.09,1.09,0,0,0-1.09,1.1h0A1.09,1.09,0,0,0,115.64,304.83Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.64,304.83H155a1.09,1.09,0,0,0,1.09-1.09h0a1.09,1.09,0,0,0-1.09-1.1H115.64a1.09,1.09,0,0,0-1.09,1.1h0A1.09,1.09,0,0,0,115.64,304.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.68,304.83h21a1.09,1.09,0,0,0,1.09-1.09h0a1.09,1.09,0,0,0-1.09-1.1h-21a1.1,1.1,0,0,0-1.1,1.1h0A1.09,1.09,0,0,0,146.68,304.83Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.68,304.83h21a1.09,1.09,0,0,0,1.09-1.09h0a1.09,1.09,0,0,0-1.09-1.1h-21a1.1,1.1,0,0,0-1.1,1.1h0A1.09,1.09,0,0,0,146.68,304.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.67,304.74h32.5a1.85,1.85,0,0,0,1.77-1.56l3.28-23.34a1.32,1.32,0,0,0-1.34-1.55H270.39a1.85,1.85,0,0,0-1.78,1.55l-3.28,23.34A1.33,1.33,0,0,0,266.67,304.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.67,304.74h32.5a1.85,1.85,0,0,0,1.77-1.56l3.28-23.34a1.32,1.32,0,0,0-1.34-1.55H270.39a1.85,1.85,0,0,0-1.78,1.55l-3.28,23.34A1.33,1.33,0,0,0,266.67,304.74Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.85,301.25l28.88-.13a1.73,1.73,0,0,0,1.64-1.44l2.56-17.62a1.21,1.21,0,0,0-1.23-1.43l-28.88.13a1.7,1.7,0,0,0-1.63,1.43l-2.57,17.63A1.21,1.21,0,0,0,268.85,301.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.85,301.25l28.88-.13a1.73,1.73,0,0,0,1.64-1.44l2.56-17.62a1.21,1.21,0,0,0-1.23-1.43l-28.88.13a1.7,1.7,0,0,0-1.63,1.43l-2.57,17.63A1.21,1.21,0,0,0,268.85,301.25Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.11 280.76 272.03 301.25 268.6 301.25 272.08 280.76 275.11 280.76",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.7,283.07l-.5.18.5.18v.19l-.71-.27v-.2l.71-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.24,282.51h.21l-.5,1.42h-.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.19,283.15v.2l-.71.27v-.19l.5-.18-.5-.18v-.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M273.86,285.22h-2a.19.19,0,0,1-.19-.19.18.18,0,0,1,.19-.19h2a.18.18,0,0,1,.19.19A.19.19,0,0,1,273.86,285.22Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M273.66,286.44h-2a.19.19,0,1,1,0-.37h2a.18.18,0,0,1,.19.18A.18.18,0,0,1,273.66,286.44Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M273.54,287.67h-2.05a.19.19,0,0,1,0-.38h2.05a.19.19,0,0,1,0,.38Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M273.29,288.89h-2a.19.19,0,1,1,0-.37h2a.18.18,0,0,1,.19.19A.18.18,0,0,1,273.29,288.89Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M273.19,290.12h-2.05a.19.19,0,1,1,0-.37h2.05a.18.18,0,0,1,.18.18A.18.18,0,0,1,273.19,290.12Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M273,291.35h-2.05a.19.19,0,0,1,0-.38H273a.19.19,0,1,1,0,.38Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M272.83,292.57h-2a.19.19,0,1,1,0-.37h2a.18.18,0,0,1,.19.19A.18.18,0,0,1,272.83,292.57Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M272.62,293.8h-2a.19.19,0,0,1-.19-.19.2.2,0,0,1,.19-.19h2a.19.19,0,0,1,.19.19A.18.18,0,0,1,272.62,293.8Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M272.35,295h-2a.19.19,0,0,1-.19-.19.18.18,0,0,1,.19-.19h2a.18.18,0,0,1,.19.19A.19.19,0,0,1,272.35,295Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M278.88,291.33h-4.2a.19.19,0,0,1-.18-.19.18.18,0,0,1,.18-.19h4.2a.19.19,0,0,1,.19.19A.2.2,0,0,1,278.88,291.33Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.77,285.22h-4.19a.19.19,0,0,1-.19-.19.18.18,0,0,1,.19-.19h4.19a.19.19,0,0,1,.19.19A.2.2,0,0,1,279.77,285.22Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.92,291.33H280a.2.2,0,0,1-.19-.19A.19.19,0,0,1,280,291h10.93a.18.18,0,0,1,.18.19A.19.19,0,0,1,290.92,291.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293,286.44h-3.16a.18.18,0,0,1-.19-.19.18.18,0,0,1,.19-.18H293a.19.19,0,1,1,0,.37Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.65,292.57h-6.49a.19.19,0,1,1,0-.37h6.49a.19.19,0,1,1,0,.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.38,292.57H283a.18.18,0,0,1-.19-.18.18.18,0,0,1,.19-.19h6.39a.19.19,0,1,1,0,.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.32,292.57h-6.9a.19.19,0,1,1,0-.37h6.9a.19.19,0,1,1,0,.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282,293.8h-3.89a.19.19,0,0,1-.19-.19.2.2,0,0,1,.19-.19H282a.19.19,0,0,1,.19.19A.18.18,0,0,1,282,293.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.49,293.8h-4.25a.18.18,0,0,1-.19-.19.19.19,0,0,1,.19-.19h4.25a.2.2,0,0,1,.19.19A.19.19,0,0,1,287.49,293.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.35,293.8h-6.89a.18.18,0,0,1-.19-.19.19.19,0,0,1,.19-.19h6.89a.2.2,0,0,1,.19.19A.19.19,0,0,1,295.35,293.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.18,286.44h-5.24a.18.18,0,0,1-.18-.19.18.18,0,0,1,.18-.18h5.24a.18.18,0,0,1,.19.18A.18.18,0,0,1,281.18,286.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.71,287.67h-5.89a.19.19,0,0,1,0-.38h5.89a.19.19,0,0,1,0,.38Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.56,287.67h-8.88a.19.19,0,0,1,0-.38h8.88a.19.19,0,0,1,0,.38Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.25,285.22h-8.89a.19.19,0,0,1-.18-.19.18.18,0,0,1,.18-.19h8.89a.18.18,0,0,1,.18.19A.19.19,0,0,1,297.25,285.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,287.67h-5.33a.19.19,0,0,1,0-.38H298a.19.19,0,0,1,0,.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.83,288.89h-3.38a.18.18,0,0,1-.18-.18.18.18,0,0,1,.18-.19h3.38a.19.19,0,1,1,0,.37Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.45,288.89H282a.19.19,0,1,1,0-.37h6.47a.18.18,0,0,1,.19.19A.18.18,0,0,1,288.45,288.89Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.3,285.22h-6.47a.2.2,0,0,1-.19-.19.19.19,0,0,1,.19-.19h6.47a.18.18,0,0,1,.19.19A.19.19,0,0,1,287.3,285.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296,288.89h-6.32a.18.18,0,0,1-.19-.18.18.18,0,0,1,.19-.19H296a.19.19,0,1,1,0,.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.75,286.44h-6.32a.18.18,0,0,1-.19-.19.18.18,0,0,1,.19-.18h6.32a.19.19,0,1,1,0,.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.2,290.12h-4a.18.18,0,0,1-.19-.19.18.18,0,0,1,.19-.18h4a.18.18,0,0,1,.19.18A.18.18,0,0,1,283.2,290.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.81,290.12H284a.19.19,0,1,1,0-.37h3.79a.18.18,0,0,1,.19.18A.18.18,0,0,1,287.81,290.12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.93,290.12H289a.19.19,0,1,1,0-.37h6.93a.18.18,0,0,1,.19.18A.18.18,0,0,1,295.93,290.12Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.25,295h-4.86a.2.2,0,0,1-.19-.19.19.19,0,0,1,.19-.19h4.86a.18.18,0,0,1,.19.19A.19.19,0,0,1,283.25,295Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.71,304.83h39.34a1.09,1.09,0,0,0,1.09-1.09h0a1.09,1.09,0,0,0-1.09-1.1H246.71a1.09,1.09,0,0,0-1.09,1.1h0A1.09,1.09,0,0,0,246.71,304.83Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.71,304.83h39.34a1.09,1.09,0,0,0,1.09-1.09h0a1.09,1.09,0,0,0-1.09-1.1H246.71a1.09,1.09,0,0,0-1.09,1.1h0A1.09,1.09,0,0,0,246.71,304.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.74,304.83h21a1.09,1.09,0,0,0,1.09-1.09h0a1.09,1.09,0,0,0-1.09-1.1h-21a1.09,1.09,0,0,0-1.09,1.1h0A1.09,1.09,0,0,0,277.74,304.83Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.74,304.83h21a1.09,1.09,0,0,0,1.09-1.09h0a1.09,1.09,0,0,0-1.09-1.1h-21a1.09,1.09,0,0,0-1.09,1.1h0A1.09,1.09,0,0,0,277.74,304.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338,193.74l2.14,1.68a3.17,3.17,0,0,1,1.21,2.64l-.23,4.78a5.91,5.91,0,0,1-2.7,4.69l-1,.64c-3.74-2.54-5.91-8-5.91-8l-.79-1.51a2.64,2.64,0,0,1,1-3.6l3-1.61A3,3,0,0,1,338,193.74Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.79,208.05l-.15.33-.11.25c-.07.16-.15.31-.22.45s-.29.57-.44.83c-.29.54-.6,1.06-.91,1.56-.63,1-1.3,1.95-2,2.87a46,46,0,0,1-4.53,5.09c-.81.79-1.64,1.54-2.48,2.28s-1.72,1.42-2.61,2.09a58.78,58.78,0,0,1-5.48,3.73l-.23.14a3.34,3.34,0,0,1-.57.28,8.89,8.89,0,0,1-3.49.53,10,10,0,0,1-3-.62,15.51,15.51,0,0,1-4.25-2.44,26.4,26.4,0,0,1-3.12-2.89c-.93-1-1.8-2-2.6-3.05s-1.56-2.1-2.28-3.17-1.4-2.16-2.06-3.25-1.28-2.2-1.88-3.32l-.87-1.7c-.28-.57-.55-1.13-.83-1.75a2.35,2.35,0,0,1,4-2.4l.05.06,1.08,1.4c.37.48.74,1,1.12,1.42.74.95,1.51,1.87,2.27,2.79s1.55,1.81,2.34,2.69,1.59,1.73,2.41,2.54,1.63,1.6,2.47,2.31A22.53,22.53,0,0,0,354,219a7.78,7.78,0,0,0,2.22,1,1.76,1.76,0,0,0,.63.06c.11,0,.12-.06.13-.08l-.8.42c1.56-1.15,3.06-2.37,4.51-3.62.72-.62,1.42-1.28,2.11-1.93s1.35-1.33,2-2c.32-.34.64-.69.94-1s.62-.7.93-1.05c.6-.71,1.17-1.45,1.72-2.17s1.07-1.48,1.55-2.23c.24-.37.46-.74.67-1.1.11-.18.21-.36.3-.53l.13-.24.06-.1,0,0h0v0a4.73,4.73,0,1,1,8.72,3.68Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.99 139.52 320.81 139.28 338.7 198.7 337.4 199.09 319.99 139.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.99 139.52 320.81 139.28 338.7 198.7 337.4 199.09 319.99 139.52",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.9 217.44 366.34 223.81 368.95 221.71 361.6 215.69 359.9 217.44",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.42,203.11a120.3,120.3,0,0,0-6.4,31.21c.34,1.5.76,3,1.24,4.53.94-1.39,2.5-2.89,3.55-4.27.57-14.24,1.89-27.93,3.05-31.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.36 205.3 387.33 201.8 389.86 200.91 391.62 202.17 388.36 205.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.86,200.91s1.46,2.19,3.2,4.38c2.92-1.26,9.81-4.69,9.86-8.41a3.7,3.7,0,0,0-1.64-1.87A40.27,40.27,0,0,1,389.86,200.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.86,200.91a19.65,19.65,0,0,0-4,3.76c-1.9-1.58-.18-8.34.64-9a4.77,4.77,0,0,1,2.82-.68S386.71,199.85,389.86,200.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.94 411.16 358.36 410.26 359.27 394.18 365.84 395.09 364.94 411.16",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.84 395.09 359.27 394.18 358.7 404.15 365.33 404.15 365.84 395.09",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.86,409.47l7.43-.47a.48.48,0,0,1,.52.42h0l.73,5.86a1.18,1.18,0,0,1-1.08,1.25c-2.6.12-3.84,0-7.12.22a61.17,61.17,0,0,1-8.73.28c-2.77-.27-2.43-3-1.23-3.13a18.31,18.31,0,0,0,8.37-4A1.83,1.83,0,0,1,357.86,409.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.7,410.27h0c0-.11-.11-2-.8-2.58a1,1,0,0,0-.74-.18.64.64,0,0,0-.56.51,2.34,2.34,0,0,0,.65,1.51,2.74,2.74,0,0,0-1.84-.34.59.59,0,0,0-.33.46.82.82,0,0,0,.24.85,1.76,1.76,0,0,0,1.26.25,7.8,7.8,0,0,0,1.73-.34.06.06,0,0,0,.06,0s0,0,0,0,.15,0,.16-.06l.14,0Zm-1.83-2.2c0-.09.06-.2.28-.24h.08a.49.49,0,0,1,.34.12,3.42,3.42,0,0,1,.56,2l-.14-.08A3.18,3.18,0,0,1,355.87,408.07Zm-1.35,2.19a.54.54,0,0,1-.14-.54.28.28,0,0,1,.16-.23c.42-.19,1.55.29,2.35.73C355.72,410.53,354.85,410.55,354.52,410.26Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.38 411.16 406.8 410.26 405.89 394.62 412.46 395.53 413.38 411.16",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.46 395.53 405.89 394.63 406.44 404.15 412.97 404.15 412.46 395.53",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.3,409.47l7.44-.47a.47.47,0,0,1,.51.42h0l.72,5.86a1.18,1.18,0,0,1-1.08,1.25c-2.59.12-3.84,0-7.11.22a61.37,61.37,0,0,1-8.74.28c-2.77-.27-2.43-3-1.23-3.13a18.26,18.26,0,0,0,8.37-4A1.83,1.83,0,0,1,406.3,409.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.14,410.27h0c0-.11-.11-2-.8-2.58a1,1,0,0,0-.74-.18.64.64,0,0,0-.56.51,2.34,2.34,0,0,0,.65,1.51,2.72,2.72,0,0,0-1.83-.34.6.6,0,0,0-.34.46.82.82,0,0,0,.24.85,1.78,1.78,0,0,0,1.27.25,7.82,7.82,0,0,0,1.72-.34.06.06,0,0,0,.06,0s0,0,0,0,.16,0,.17-.06l.13,0Zm-1.82-2.2c0-.09.06-.2.27-.24h.08a.47.47,0,0,1,.34.12,3.42,3.42,0,0,1,.56,2l-.14-.08A3.1,3.1,0,0,1,404.32,408.07ZM403,410.26a.56.56,0,0,1-.14-.54.28.28,0,0,1,.16-.23c.42-.19,1.56.29,2.36.73C404.17,410.53,403.3,410.55,403,410.26Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,257.71v25.66c-7.91,21.11-20,56-22.05,67.38s-1.55,25.31-5.28,50.55l-13,.31s-.9-28.85,1-50S375,257.71,375,257.71Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.89,257.71c1.51,11.39-3.71,87.49-2.41,98.08S413.32,376,415,401.61h-12.2s-6.36-24.28-9.63-45.55-5.15-77.65-3-98.35Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.9,318.73s1.24-11.83,1.57-16.65,3.5-18.16,3.5-18.16l.54,18.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,224.14c-.5-4.81-1.21-11.41-2.07-15.45a36.55,36.55,0,0,0,3.06,2.42",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.66,204.3c.63,6.84-16.12,21.66-16.12,21.66l-11.72-11.42a86.32,86.32,0,0,1,12.39-13.88C379.09,194.78,387,196.8,387.66,204.3Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.66,204.3c.63,6.84-16.12,21.66-16.12,21.66l-11.72-11.42a86.32,86.32,0,0,1,12.39-13.88C379.09,194.78,387,196.8,387.66,204.3Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.31,213.06c-3.37,1.8-7.59,7.2-7.84,11.9l1,1s7.86-7.09,12-12.64C382.38,211.74,382.18,211,378.31,213.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.72,198.21a159.34,159.34,0,0,0-3,23.74c-.31,5.58-.38,10.88-.32,15.69.14,11.26.94,19.8.8,22.72-5.62-.08-26.78-.38-38.32-.56-7.83-40.35.72-61.83.72-61.83a75.46,75.46,0,0,1,9.06-1.63c.64-.07,1.3-.13,2-.18a140.17,140.17,0,0,1,16.29.24c1,.06,2.07.15,3.08.26C411.14,197.21,415.72,198.21,415.72,198.21Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.72,198.21a159.34,159.34,0,0,0-3,23.74c-.31,5.58-.38,10.88-.32,15.69.14,11.26.94,19.8.8,22.72-5.62-.08-26.78-.38-38.32-.56-7.83-40.35.72-61.83.72-61.83a75.46,75.46,0,0,1,9.06-1.63c.64-.07,1.3-.13,2-.18a140.17,140.17,0,0,1,16.29.24c1,.06,2.07.15,3.08.26C411.14,197.21,415.72,198.21,415.72,198.21Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,203.59c-1,2.86-2.59,5.22-3.77,12.65.46,1.56,1,3.13,1.6,4.69q1.35-2.28,2.86-4.55c.53-7.17-.17-9.07.84-12.71Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.89 205.9 387.59 202.29 390.19 201.19 392.13 202.41 388.89 205.9",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,196.66a124.65,124.65,0,0,0-19.33,24.27c-3.22-8.3-4.36-16.48-2.88-24.48a76.92,76.92,0,0,0-8.19,1.52s-8.55,21.48-.72,61.83c11.54.18,32.7.48,38.32.56.14-2.92-.66-11.46-.8-22.72-.06-4.81,0-10.11.32-15.69a159.34,159.34,0,0,1,3-23.74S411.14,197.21,406,196.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.19,201.19s1.68,2.21,3.65,4.4c3-1.51,10-5.56,9.84-9.46a3.91,3.91,0,0,0-1.85-1.87A42.34,42.34,0,0,1,390.19,201.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.19,201.19a20.94,20.94,0,0,0-3.95,4.21c-2.1-1.54-.72-8.76.11-9.55a5,5,0,0,1,2.92-.9S386.81,200.27,390.19,201.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.19,203.77c1.19,2.4,2.19,4.71,3.21,7.1s1.92,4.79,2.79,7.25,1.65,5,2.3,7.6a41.23,41.23,0,0,1,1.35,8.48,20.43,20.43,0,0,1-.08,2.55,14.14,14.14,0,0,1-.23,1.46c-.06.26-.12.51-.2.8l-.13.42-.18.5a9.28,9.28,0,0,1-2.23,3.23,11.77,11.77,0,0,1-2.57,1.79,18.53,18.53,0,0,1-4.67,1.58,33,33,0,0,1-4.26.56,60.38,60.38,0,0,1-15.8-1.28l.48-5.35,3.62-.27c1.21-.1,2.42-.24,3.61-.36a70.33,70.33,0,0,0,7-1.09,25.43,25.43,0,0,0,3.11-.87,9,9,0,0,0,2.32-1.1,1.66,1.66,0,0,0,.45-.43c0-.08-.07,0-.16.13l0,.06s0,0,0,0v-.12c0-.1,0-.25,0-.41a9,9,0,0,0-.07-1.19,35.91,35.91,0,0,0-1.43-6.26c-.69-2.21-1.46-4.46-2.34-6.69-1.7-4.46-3.66-9-5.62-13.35Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.75,240.36l-6-4.14-1.54,9.06s5.85,2.38,7.44-.61Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.85 236.56 388.92 244.11 394.25 245.28 395.79 236.22 389.85 236.56",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.77,179.85c-.77,4.43-1.46,12.54,1.69,15.42,0,0-4,6.09-10.58,6.37-5.66.25-3.15-6.07-3.15-6.07,4.91-1.29,4.7-4.94,3.77-8.35Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.4,182.85l-4.9,4.37a14.2,14.2,0,0,1,.48,2.42c1.88-.31,5.92-4.32,6.08-6.29C398.15,182.55,396.6,183.63,396.4,182.85Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.39,163.3c3.12,2.11,1.7,5.69-5.34,11.29-2.86-3.71-3.33-10.91-1.06-12.72S385.68,161.47,388.39,163.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.78,169.1c-.34,7.6-.16,12.06-3.92,16-5.67,6-15.11,2.64-17.05-4.91-1.74-6.79-.9-18.09,6.48-21.23a10.39,10.39,0,0,1,14.49,10.11Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.47,171.37c0,.62-.31,1.13-.72,1.13s-.73-.48-.74-1.1.3-1.12.7-1.14S390.42,170.76,390.47,171.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.44,171.5c0,.62-.31,1.12-.71,1.13s-.75-.48-.76-1.11.31-1.12.72-1.13S383.43,170.88,383.44,171.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.74,171.75a22.19,22.19,0,0,1-2.87,5.34,3.58,3.58,0,0,0,3,.5Z",
    style: {
      fill: "#d08245"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.35,169.12a.37.37,0,0,0,.23-.05.37.37,0,0,0,.07-.51,3.57,3.57,0,0,0-3-1.45.35.35,0,0,0-.34.36v0a.37.37,0,0,0,.39.33h0a2.86,2.86,0,0,1,2.34,1.17A.36.36,0,0,0,392.35,169.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.2,169.18a.36.36,0,0,0,.33-.21,2.85,2.85,0,0,1,2-1.67.38.38,0,0,0,.31-.42.37.37,0,0,0-.4-.31,3.62,3.62,0,0,0-2.58,2.1.37.37,0,0,0,.17.48h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.64,162.41c-3.54,1.28-3,5.1,2.42,12.25,3.68-2.9,5.91-9.77,4.14-12.07S401.72,161.3,398.64,162.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5,175.11a7.26,7.26,0,0,1-3.37,4.39c-2.21,1.24-3.91-.59-3.81-3,.1-2.17,1.36-5.42,3.82-5.68S406.1,172.84,405.5,175.11Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.83,180.44a17.32,17.32,0,0,0,5.71-2.52,4.73,4.73,0,0,1-3.84,5.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.07,183.1a4.33,4.33,0,0,0,2.37-2.9,3.33,3.33,0,0,0-2,1A2.44,2.44,0,0,0,389.07,183.1Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.67,173.61h-2.85a1.43,1.43,0,0,1-1.43-1.43v-1.81a1.43,1.43,0,0,1,1.43-1.42h2.85a1.43,1.43,0,0,1,1.43,1.42v1.81A1.43,1.43,0,0,1,383.67,173.61Zm-2.85-3.81a.58.58,0,0,0-.58.57v1.81a.58.58,0,0,0,.58.58h2.85a.58.58,0,0,0,.58-.58v-1.81a.58.58,0,0,0-.58-.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.49,173.61h-2.85a1.43,1.43,0,0,1-1.43-1.43v-1.81a1.43,1.43,0,0,1,1.43-1.42h2.85a1.43,1.43,0,0,1,1.43,1.42v1.81A1.43,1.43,0,0,1,390.49,173.61Zm-2.85-3.81a.58.58,0,0,0-.58.57v1.81a.58.58,0,0,0,.58.58h2.85a.58.58,0,0,0,.58-.58v-1.81a.58.58,0,0,0-.58-.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.68,
    y: 170.85,
    width: 1.96,
    height: 0.85,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.94,
    y: 170.85,
    width: 7.33,
    height: 0.85,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.9 224.14 426.95 220.39 427.87 223.4 417.79 226.71 416.9 224.14",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.63 220.94 412.38 237.64 412.58 225.98 410.63 220.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.81,198.88c6.24,2.84,11.82,22.54,11.82,22.54l-16.74,5.29a100.89,100.89,0,0,1-5.58-17.2C405.32,200.05,410.24,195.43,417.81,198.88Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.81,198.88c6.24,2.84,11.82,22.54,11.82,22.54l-16.74,5.29a100.89,100.89,0,0,1-5.58-17.2C405.32,200.05,410.24,195.43,417.81,198.88Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "192.85 290.38 191.8 296.99 186.51 299.17 186.25 291.65 192.85 290.38",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.12,226.86c.1.52.46.88.8.81s.52-.54.42-1.06-.46-.87-.8-.8S212,226.35,212.12,226.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.53,227.75a18.89,18.89,0,0,0,3.36,3.9,3,3,0,0,1-2.37,1Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.65,224.39a.3.3,0,0,1-.21-.09.3.3,0,0,1,0-.43,3,3,0,0,1,2.62-1,.3.3,0,0,1,.25.35.31.31,0,0,1-.35.26h0a2.43,2.43,0,0,0-2.07.83A.33.33,0,0,1,209.65,224.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.45,234.1c.94,4.77,1.87,13.5-1.46,16.68,0,0,1.3,4.83,10.15,4.83,9.74,0,4.66-4.83,4.66-4.83-5.32-1.27-5.18-5.21-4.26-8.91Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.06,251.66c-.71-1.32-1.49-2.84.13-3.31,1.78-.52,13.24-1.49,16.61-.51-1,1.84.72,4.1.72,4.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.21,262.31l-2.56,4.45-2.51,4.56c-1.65,3-3.22,6.1-4.66,9.18-.72,1.55-1.4,3.08-2,4.63l-.12.28,0,.06a.56.56,0,0,0-.07.13,1.17,1.17,0,0,0-.12.25,1.7,1.7,0,0,0,.11,1,9.73,9.73,0,0,0,2.13,3.24,37.1,37.1,0,0,0,3.46,3.28l-2.08,4.43a21.36,21.36,0,0,1-2.86-1,22.39,22.39,0,0,1-2.71-1.39,15.44,15.44,0,0,1-5-4.63,10.43,10.43,0,0,1-1.56-4.05,9.25,9.25,0,0,1,0-2.41,9.09,9.09,0,0,1,.21-1.18l.14-.58.11-.35c.57-1.81,1.16-3.6,1.85-5.33,1.35-3.48,2.87-6.85,4.53-10.12q1.23-2.46,2.59-4.85c.91-1.61,1.79-3.16,2.83-4.78Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.59,292.86l4.66-1.21.26,7.52s-3.64.55-5.87-1.68Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.32,252.25c-6.1,1.4-11.14,17-11.14,17l12.26,9.34a26.78,26.78,0,0,0,6.51-12C194,258.37,190.57,250.82,184.32,252.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.32,252.25c-6.1,1.4-11.14,17-11.14,17l12.26,9.34a26.78,26.78,0,0,0,6.51-12C194,258.37,190.57,250.82,184.32,252.25Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.56,263.71c-3.32,3.28-4.4,9.26-4.66,14.46l.54.41a26.67,26.67,0,0,0,6.51-12c.12-.49.23-1,.32-1.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.81,252.59s6.94,7.83.39,56.3H186.36c-.24-5.35,3.12-31.44-2-56.64A90.21,90.21,0,0,1,196,250.78a126.07,126.07,0,0,1,14.81,0A64.85,64.85,0,0,1,220.81,252.59Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.81,252.59s6.94,7.83.39,56.3H186.36c-.24-5.35,3.12-31.44-2-56.64A90.21,90.21,0,0,1,196,250.78a126.07,126.07,0,0,1,14.81,0A64.85,64.85,0,0,1,220.81,252.59Z",
    style: {
      fill: "#FF725E",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.73,229.26c1.67,6.24,2.33,10,6.18,12.58,5.8,3.91,13-.58,13.24-7.19.21-6-2.57-15.17-9.27-16.43A8.81,8.81,0,0,0,194.73,229.26Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.59,239.44c2.66,1.52,12.34-3.56,10.35-11.25a16.54,16.54,0,0,0,2-3.29c.33-.71.64,3.7.88,2.85a62.09,62.09,0,0,0,.38-8.89c-.42-4.89-3.78-6.76-7.35-5.71-3.15.93-3.06,2.65-3.06,2.65s-14.88,1.75-11.71,7.81C183,230.21,194.28,237.55,197.59,239.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.51,224.11s-1.77-3.07-4.36-1.35C186.37,222.78,188.37,223,189.51,224.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.86,224.81s.78-11.25-7.05-11.94A17.62,17.62,0,0,1,212.86,224.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.35,229.52a7.27,7.27,0,0,0,2.63,3.89c1.69,1.26,3,0,2.84-1.9-.11-1.73-1.12-4.46-3-5S204.86,227.65,205.35,229.52Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,252.59s6.93,7.83.39,56.3H186.25c-.24-5.35,3.12-31.44-2-56.64a90.21,90.21,0,0,1,11.66-1.47,126.07,126.07,0,0,1,14.81,0A65.13,65.13,0,0,1,220.7,252.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.46,269.52l-.13-.11-7.92,1.9c-.45,5.35,5.05,11.75,7.89,14.68A152.59,152.59,0,0,0,223.46,269.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,258.53c1,1.56,2.14,3.31,3.28,4.93s2.32,3.26,3.55,4.83a65.65,65.65,0,0,0,7.76,8.66c.68.64,1.38,1.22,2.09,1.77l.53.4a1.21,1.21,0,0,0-.31-.11c-.23,0-.34,0-.28,0a2.91,2.91,0,0,0,1.46-.34,17.22,17.22,0,0,0,2.24-1.16,79.1,79.1,0,0,0,9.37-7.26l3.8,3.07A45,45,0,0,1,249,283.76,21.1,21.1,0,0,1,246,286a11.91,11.91,0,0,1-4.47,1.66,7.82,7.82,0,0,1-3.39-.29,7.57,7.57,0,0,1-1.73-.79l-.77-.49c-1-.66-2-1.35-2.89-2.07a64.09,64.09,0,0,1-9.55-9.59c-1.39-1.72-2.74-3.46-4-5.26s-2.45-3.57-3.62-5.6Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23,262.44c-2.08,8.73,13.72,17.29,13.72,17.29l10.26-12A85.28,85.28,0,0,0,224.73,255C217.55,248.15,212.82,255.79,211.23,262.44Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23,262.44c-2.08,8.73,13.72,17.29,13.72,17.29l10.26-12A85.28,85.28,0,0,0,224.73,255C217.55,248.15,212.82,255.79,211.23,262.44Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.68,272.1l2.43-7.78,6.37,3.18s-.93,5.67-5.57,6.65Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.66 262.16 263.41 263.75 261.48 267.5 255.11 264.32 257.66 262.16",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.8,215.8s-1.23-1.94-4.81-.74a4.06,4.06,0,0,0-2.75,2.57l3.93,2.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.41 392.93 258.09 400.84 266.68 399.71 265.43 390.93 256.41 392.93",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.27,399.72a.21.21,0,0,1-.19-.16.2.2,0,0,1,.08-.23c.13-.09,3.1-2.2,4.64-1.93a1.09,1.09,0,0,1,.72.43.8.8,0,0,1,.11.93c-.32.52-1.46.84-2.58.95A16.13,16.13,0,0,1,268.27,399.72Zm.66-.35c1.7,0,4-.2,4.33-.82.05-.08.1-.22-.09-.47a.56.56,0,0,0-.45-.25,1.4,1.4,0,0,0-.41,0A9.92,9.92,0,0,0,268.93,399.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.15,399.72a.2.2,0,0,1-.11-.18c0-.12,0-2.57,1.06-3.63a1.6,1.6,0,0,1,1.15-.48c.59,0,.81.28.85.52.29,1-1.68,3.17-2.71,3.75a.15.15,0,0,1-.09,0A.2.2,0,0,1,268.15,399.72Zm2-3.87a1.11,1.11,0,0,0-.72.34,5,5,0,0,0-.92,2.88c1.05-.77,2.32-2.44,2.21-3,0-.06-.07-.21-.45-.2l-.12,0Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.22,398.55l-9.84,1a.79.79,0,0,0-.71.69l-1,8.18a1.34,1.34,0,0,0,1.42,1.49c3.54-.41,6.68-.91,11.09-1.34,5.22-.51,3.95.24,10.09-.27,3.7-.32,4-4.58,2.37-4.63-7.25-.2-8.2-2.29-11.22-4.58A3.14,3.14,0,0,0,267.22,398.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.09 395.54 257.11 396.25 256.41 392.93 265.43 390.93 266.09 395.54",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.81 327.45 267.29 389.76 254.11 390.79 238.77 329.02 258.81 327.45",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.81 327.45 267.29 389.76 254.11 390.79 238.77 329.02 258.81 327.45",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.9,389.88l15.88-1.26a3.45,3.45,0,0,1-.13,3.93l-15.33,1.38S251.8,393.05,252.9,389.88Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.26,309.06s-.91,9-.79,12.23c.68,16.87,16.66,22.82,29.4,20.48l45.26-4.9c1.84,6.13,23.16,39.89,23.16,39.89l11.21-6.44s-11.62-27.87-19.12-47.26c-4.29-11.07-38.29-11.41-51.13-9.13-3.91,1.05-3.15-5-3.15-5Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.15 377.38 290.43 384.52 298.42 380.54 294.26 372.42 286.15 377.38",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,380a.21.21,0,0,1-.23-.09.2.2,0,0,1,0-.25c.09-.13,2.28-3.17,3.87-3.43a1.11,1.11,0,0,1,.85.18.82.82,0,0,1,.41.86c-.14.62-1.14,1.31-2.19,1.79A16.09,16.09,0,0,1,300,380Zm.53-.56c1.67-.53,3.8-1.52,3.94-2.25,0-.1,0-.24-.24-.42a.6.6,0,0,0-.52-.1,1.48,1.48,0,0,0-.41.12A10.27,10.27,0,0,0,300.49,379.46Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.85,380.06a.2.2,0,0,1-.17-.14c0-.11-.86-2.5-.18-3.88a1.62,1.62,0,0,1,1-.85c.58-.2.88,0,1,.22.62.87-.58,3.64-1.38,4.55a.13.13,0,0,1-.09.05A.2.2,0,0,1,299.85,380.06Zm.65-4.43a1.11,1.11,0,0,0-.58.57,5.16,5.16,0,0,0,.06,3.11c.77-1.1,1.45-3.15,1.13-3.7,0-.05-.13-.18-.5-.05l-.11.07Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.56,379.23l-9.26,4.24a.83.83,0,0,0-.46.91l1.77,8.29a1.37,1.37,0,0,0,1.61,1.06,1.31,1.31,0,0,0,.28-.09c3.31-1.58,6.19-3.12,10.34-5,4.9-2.24,3.93-1.09,9.73-3.64,3.49-1.54,2.32-5.78.76-5.3-7.12,2.23-8.75.52-12.46-.7A3.24,3.24,0,0,0,298.56,379.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.33 381.01 286.15 377.38 294.26 372.42 296.27 376.34 288.33 381.01",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.51,377.34l13.9-8.67a3.53,3.53,0,0,1,1.75,3.64l-13.35,8.53S282,380.76,281.51,377.34Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.99 345.34 207.26 357.02 208.49 416.95 212.54 416.95 213.77 357.02 214.04 345.34 206.99 345.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.99 345.34 207.26 357.02 208.49 416.95 212.54 416.95 213.77 357.02 214.04 345.34 206.99 345.34",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.99 345.34 207.26 357.34 213.77 357.34 214.04 345.34 206.99 345.34",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.95 416.76 188.7 346.17 194.82 346.17 189.58 416.76 184.95 416.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.59 416.76 184.95 416.76 188.36 351.87 188.69 346.09 194.82 346.09 194.35 351.87 189.59 416.76",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.82 346.09 194.35 352.09 188.36 352.09 188.69 346.09 194.82 346.09",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.45 416.76 226.2 346.17 232.33 346.17 236.08 416.76 231.45 416.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.44 416.76 226.68 351.87 226.21 346.09 232.33 346.09 232.67 351.87 236.07 416.76 231.44 416.76",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.21 346.09 226.68 352.09 232.67 352.09 232.33 346.09 226.21 346.09",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.41,339.59h50.2a0,0,0,0,1,0,0v4.54a4.23,4.23,0,0,1-4.23,4.23H189.64a4.23,4.23,0,0,1-4.23-4.23v-4.54A0,0,0,0,1,185.41,339.59Z",
    transform: "translate(421.03 687.95) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.01,
    y: 343.97,
    width: 55.01,
    height: 4.38,
    rx: 1.7,
    transform: "translate(421.03 692.33) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.01,
    y: 343.97,
    width: 55.01,
    height: 4.38,
    rx: 1.7,
    transform: "translate(421.03 692.33) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.35 291.14 182.59 291.14 191.59 343.97 188.36 343.97 179.35 291.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.36 291.14 206.59 291.14 215.59 343.97 212.36 343.97 203.36 291.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.35 291.14 182.59 291.14 191.59 343.97 188.36 343.97 179.35 291.14",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.36 291.14 206.59 291.14 215.59 343.97 212.36 343.97 203.36 291.14",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.56,301.18H179.75a4.46,4.46,0,0,1-4.22-4.15l-3-12.95c-.33-2.84,1.65-5.36,4.22-5.36h29.8a4.45,4.45,0,0,1,4.22,4.15l3.05,12.95C214.1,298.67,212.12,301.18,209.56,301.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.14,
    y: 343.9,
    width: 26.76,
    height: 4.38,
    rx: 1.7,
    transform: "translate(449.04 692.18) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "130.71 395.68 132.34 403.34 140.66 402.25 139.45 393.75 130.71 395.68",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.19,402.26a.22.22,0,0,1-.18-.15.23.23,0,0,1,.08-.23c.13-.09,3-2.12,4.5-1.87a1.14,1.14,0,0,1,.69.42.77.77,0,0,1,.11.9,3.79,3.79,0,0,1-2.5.92A15.22,15.22,0,0,1,142.19,402.26Zm.65-.34c1.64,0,3.84-.19,4.19-.8.05-.07.09-.2-.09-.44a.56.56,0,0,0-.43-.25,1.35,1.35,0,0,0-.4,0A9.57,9.57,0,0,0,142.84,401.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.08,402.26a.21.21,0,0,1-.11-.18c0-.11,0-2.48,1-3.51a1.49,1.49,0,0,1,1.11-.46c.58,0,.78.27.83.5.28,1-1.63,3.07-2.63,3.63a.12.12,0,0,1-.08,0A.2.2,0,0,1,142.08,402.26Zm1.93-3.75a1.15,1.15,0,0,0-.69.33,4.89,4.89,0,0,0-.89,2.79c1-.74,2.25-2.36,2.13-2.95,0-.05-.05-.19-.43-.19l-.12,0Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.18,401.13l-9.52.93a.78.78,0,0,0-.69.68l-1,7.92a1.28,1.28,0,0,0,1.11,1.43h.27c3.43-.4,6.47-.89,10.74-1.3,5-.5,3.83.23,9.77-.26,3.58-.31,3.83-4.43,2.3-4.49-7-.19-7.95-2.21-10.87-4.43A3.06,3.06,0,0,0,141.18,401.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.09 398.22 131.4 398.9 130.71 395.68 139.45 393.75 140.09 398.22",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.03 332.29 140.46 396.99 130.71 398.11 113.63 333.82 133.03 332.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.03 332.29 140.46 396.99 130.71 398.11 113.63 333.82 133.03 332.29",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.51 380.63 163.65 387.54 171.39 383.69 167.36 375.83 159.51 380.63",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.88,383.19a.21.21,0,0,1-.23-.09.21.21,0,0,1,0-.24c.1-.13,2.21-3.08,3.75-3.33a1.13,1.13,0,0,1,.82.18.82.82,0,0,1,.41.84c-.14.59-1.11,1.26-2.13,1.73A15.92,15.92,0,0,1,172.88,383.19Zm.51-.55c1.62-.51,3.68-1.47,3.82-2.17,0-.09,0-.23-.24-.41a.6.6,0,0,0-.5-.1,1.42,1.42,0,0,0-.4.12A10.2,10.2,0,0,0,173.39,382.64Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.77,383.23a.21.21,0,0,1-.16-.14c0-.11-.83-2.42-.18-3.76a1.54,1.54,0,0,1,.93-.82c.56-.19.85,0,1,.21.6.85-.56,3.53-1.34,4.41a.14.14,0,0,1-.08.05A.22.22,0,0,1,172.77,383.23Zm.63-4.3a1.09,1.09,0,0,0-.56.56,5,5,0,0,0,.06,3c.74-1.07,1.4-3.05,1.09-3.58,0-.05-.12-.18-.48-.05l-.11.06Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.52,382.43l-9,4.09a.79.79,0,0,0-.44.89l1.71,8a1.32,1.32,0,0,0,1.56,1,1.12,1.12,0,0,0,.26-.08c3.21-1.54,6-3,10-4.86,4.74-2.17,3.8-1,9.41-3.52,3.38-1.49,2.25-5.59.74-5.13-6.9,2.16-8.47.5-12.06-.68A3.11,3.11,0,0,0,171.52,382.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.62 384.14 159.51 380.63 167.36 375.83 169.31 379.63 161.62 384.14",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,308.6s-6.13,7.92-6.85,17.72c-1.21,16.31,12.63,20.54,28.46,19.84l43.82-4.75c1.77,5.94,25.94,42.1,25.94,42.1l9.05-5.19s-13-31.51-20.23-50.28c-4.15-10.72-37.07-11-49.51-8.84-3.77,1-3-4.88-3-4.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,250.91c-.14.54,0,1.06.38,1.17s.75-.25.9-.79,0-1-.38-1.16S106.29,250.38,106.15,250.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.88,250.11l1.4,0S107.34,250.94,106.88,250.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.46,251.57a15.4,15.4,0,0,0,1,4,2.41,2.41,0,0,1-2-.21Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.83,247.55a.39.39,0,0,1-.15-.06,2.78,2.78,0,0,0-2.39-.38.33.33,0,0,1-.43-.18.34.34,0,0,1,.19-.43,3.37,3.37,0,0,1,3,.45.33.33,0,0,1-.21.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.63,254.22c.13,4.19-1.66,10.94-4.95,13.08,0,0,2.12,4.52,9.66,6C101.63,274.88,98,270,98,270c-4.34-2-3.67-5.27-2.37-8.25Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,244.11c-1.35,6.72-2.06,9.52.38,13.9,3.67,6.58,12.22,7,15.55.9,3-5.51,4.7-15.57-1.08-20.1A9.15,9.15,0,0,0,88.52,244.11Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.36,248.92a6.17,6.17,0,0,0,.89,3.62c.91,1.54,2.18,1.28,2.62,0s.38-3.35-.86-4.48S101.51,247.5,101.36,248.92Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.59,276.08l-.09,1.05-.07,1.15c-.05.77-.08,1.54-.1,2.32,0,1.56,0,3.12,0,4.68a63.06,63.06,0,0,0,1,9.24l.42,2a1.2,1.2,0,0,0,.34.68,10,10,0,0,0,3,2.08,50.85,50.85,0,0,0,8.77,3.06l-.32,4.13a33.27,33.27,0,0,1-10.74-1.13,15.33,15.33,0,0,1-5.63-2.84,8.71,8.71,0,0,1-2.49-3.39l-.2-.55-.1-.33-.2-.64-.39-1.3A56,56,0,0,1,69,285.74c-.12-1.77-.18-3.55-.14-5.32q0-1.34.12-2.67c0-.45,0-.9.1-1.35s.1-.88.18-1.44Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.19,302.48l7.55-.21-3,4.61s-3.77.84-4.9-1.86Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.66 304.32 98.42 308.2 93.69 306.88 96.74 302.27 98.66 304.32",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.06,267.6C66.65,271,67.82,283,67.82,283l11.87,1.56s3.69-10.48-.23-16.33C77.51,265.33,73.4,264.26,70.06,267.6Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.62,308.25l27.77,5.38c13.11-38.62,10-39.87,10-39.87a56.58,56.58,0,0,0-6.3-2.92c-.13-.06-.26-.1-.37-.14-1.78-.65-2.15-.75-4.53-1.44-4.09-1-7.9-1.76-12.61-2.44l-.9-.12c-.85-.11-1.69-.2-2.51-.28-.55-.06-1.1-.09-1.63-.13l-1.79-.1c-3-.15-5.21-.1-5.21-.1C73.1,290.19,71.94,297.11,69.62,308.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.62,308.25l27.77,5.38c13.11-38.62,10-39.87,10-39.87a56.58,56.58,0,0,0-6.3-2.92c-.13-.06-.26-.1-.37-.14-1.78-.65-2.15-.75-4.53-1.44-4.09-1-7.9-1.76-12.61-2.44l-.9-.12c-.85-.11-1.69-.2-2.51-.28-.55-.06-1.1-.09-1.63-.13l-1.79-.1c-3-.15-5.21-.1-5.21-.1C73.1,290.19,71.94,297.11,69.62,308.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.88 297.88 155.27 301.44 151.99 302.88 150.46 298 152.88 297.88",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.53,278.63c1.11,1.74,2.3,3.62,3.53,5.4s2.47,3.58,3.74,5.34,2.58,3.48,3.92,5.17c.67.84,1.36,1.66,2,2.49.34.42.7.81,1,1.21l.53.61.26.29s0,0,.05.07a4.43,4.43,0,0,0,1.57.86,16.31,16.31,0,0,0,2.65.65,45.12,45.12,0,0,0,6.18.49c4.26.06,8.71-.16,13-.53l.83,4.06a75,75,0,0,1-13.6,2.73,43.21,43.21,0,0,1-7.23.18,23.08,23.08,0,0,1-3.93-.61,11.34,11.34,0,0,1-4.4-2.12c-.19-.15-.38-.33-.56-.5l-.32-.31-.63-.62c-.41-.42-.84-.82-1.23-1.25-.82-.83-1.61-1.69-2.38-2.56-1.55-1.73-3-3.5-4.45-5.33s-2.79-3.67-4.09-5.57-2.55-3.78-3.76-5.87Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.94,301.61l4.52-3.61,2.33,4.59s-3.79,4.22-6.73,1.45Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.75,285.51a23.31,23.31,0,0,0,.82,12.12c2.3-7.55,3.61-12.72,4.32-16.25C104.76,281.1,102.49,281.79,101.75,285.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.13,273.63c4.63,3,7.58,9.75,8.37,13.61L104.75,296s-5.85-13.07-3.93-16.41S105.38,272.49,107.13,273.63Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48,306.55l-1.66,2.23c-.13.18.06.42.38.48l29.12,5.64c.25.05.48,0,.52-.19l.66-2.42c0-.17-.15-.36-.42-.41L70,306.43A.49.49,0,0,0,69.48,306.55Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.74,310.41l-.76-.14c-.15,0-.25-.13-.22-.22l.88-3.15c0-.09.17-.14.32-.11l.75.15c.15,0,.26.12.23.22l-.88,3.14C73,310.39,72.89,310.44,72.74,310.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.75,314.14,91,314c-.15,0-.25-.12-.23-.22l.89-3.14c0-.09.17-.14.32-.11l.75.14c.15,0,.25.13.22.22L92.07,314C92,314.12,91.9,314.17,91.75,314.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,233.26a8.56,8.56,0,0,0-8,6.51c-1.48,5.08-2.61,11.62-6.15,10.93.79.83,3,1.57,3.55,1-1.84,2.65-2,4.54-1.63,9.18.41,5.79-3,5.09-3,5.09s4.72,5.3,17.12,5.27c11,0,15.55-3.3,16.63-5.56-1.56-.22-4.81-5.05-3.32-8.45s3.53-12.28,2.36-15.5c1.66,1.83,2.31,5.08,2.81,1.61s.38-7-4.37-10.38C99.21,230,88.43,230,87.4,233.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,243c0,3-1.73,5.35-3.86,5.35S81.26,246,81.26,243s1.73-5.34,3.87-5.34S89,240.06,89,243Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.89,234.14c-3.39-2.23-9.68,1.12-12.65,4.15S63,250.83,63,250.83a15.93,15.93,0,0,1-11.17,5s10.89,5,14.36,4.45,6.17-3.82,6.17-3.82c-1.8,3.87-3.88,7.13-6.89,8.35a18.24,18.24,0,0,0,10-5.76c2.38-2.79,2.54-9.46,2.54-9.46s4.09.55,6.45-2.32S86.27,236.38,82.89,234.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.64 345.56 81.91 357.24 83.14 417.17 87.19 417.17 88.42 357.24 88.69 345.56 81.64 345.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.64 345.56 81.91 357.24 83.14 417.17 87.19 417.17 88.42 357.24 88.69 345.56 81.64 345.56",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.64 345.56 81.91 357.56 88.42 357.56 88.69 345.56 81.64 345.56",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.6 416.99 63.35 346.39 69.47 346.39 64.23 416.99 59.6 416.99",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.24 416.99 59.6 416.99 63.01 352.09 63.34 346.31 69.47 346.31 69 352.09 64.24 416.99",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.47 346.31 69 352.31 63.01 352.31 63.34 346.31 69.47 346.31",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.1 416.99 100.85 346.39 106.98 346.39 110.73 416.99 106.1 416.99",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.09 416.99 101.33 352.09 100.86 346.31 106.98 346.31 107.32 352.09 110.72 416.99 106.09 416.99",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.86 346.31 101.33 352.31 107.32 352.31 106.98 346.31 100.86 346.31",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.06,339.81h50.2a0,0,0,0,1,0,0v4.54a4.23,4.23,0,0,1-4.23,4.23H64.29a4.23,4.23,0,0,1-4.23-4.23v-4.54A0,0,0,0,1,60.06,339.81Z",
    transform: "translate(170.33 688.39) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.66,
    y: 344.19,
    width: 55.01,
    height: 4.38,
    rx: 1.7,
    transform: "translate(170.33 692.77) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.66,
    y: 344.19,
    width: 55.01,
    height: 4.38,
    rx: 1.7,
    transform: "translate(170.33 692.77) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54 291.36 57.24 291.36 66.24 344.19 63.01 344.19 54 291.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.01 291.36 81.24 291.36 90.25 344.19 87.01 344.19 78.01 291.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54 291.36 57.24 291.36 66.24 344.19 63.01 344.19 54 291.36",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.01 291.36 81.24 291.36 90.25 344.19 87.01 344.19 78.01 291.36",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.21,301.41H54.4a4.46,4.46,0,0,1-4.22-4.16l-3-12.95c-.33-2.84,1.65-5.36,4.22-5.36h29.8a4.45,4.45,0,0,1,4.22,4.15l3.05,13C88.75,298.89,86.77,301.41,84.21,301.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.79,
    y: 344.12,
    width: 26.76,
    height: 4.38,
    rx: 1.7,
    transform: "translate(198.34 692.62) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingAssessmentRight);
export default __webpack_public_path__ + "static/media/Coding Assessment_right.250b576f9734c58e0a1f46cdff2601c7.svg";
export { ForwardRef as ReactComponent };